import React, { useState, useMemo, useContext, useEffect } from "react";
// react plugin used to create charts
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, LineController, LineElement, PointElement } from "chart.js";
import { Spinner } from "reactstrap"; 
// react plugin for creating vector maps
// import { VectorMap } from "react-jvectormap"; // Not used
import { DataContext } from "../context/DataContext";
import AddNewOrderModal from "./AddNewOrderModal";
import {
  createTask,
  deleteOrder,
  deleteTask,
  getOrderDetails,
  updateTask,
} from "../context/api";
import Select, { components } from "react-select";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { fetchDashboardComparison, fetchDashboardYearParts } from "../utils/dashboardApi";
import { buildDashboardYearBlockFromTerritories } from "../utils/dashboardRollup";
import { API_BASE } from "../config/api";
import {
  canEditOrders,
  getOrderActivityTimestamp,
  syncOrderIntoCustomers,
} from "../utils/orderHistory";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
  Modal, // Added Modal
  ModalHeader, // Added ModalHeader
  ModalBody, // Added ModalBody
  ModalFooter, // Added ModalFooter
  ListGroup,
  ListGroupItem
} from "reactstrap";

import {
  chartExample1,
  chartExample2,
  chartExample3,
  chartExample4,
  chartBitters,
  chartCider,
  chartWine,
  chartNonAlc,
  chartSpirits,
  chartMead,
  chartRTD,
  chartCocktails,
  getBrandColor,
  brandColorPalette,
} from "variables/charts.js";

ChartJS.register(LineController, LineElement, PointElement);

// var mapData = { ... }; // Not used

// Sample 20 customers with dummy lat/lng
const customerMarkers = [
  // { latLng: [-36.8485, 174.7633], name: "Doe Liquor Store", territory: "Northern", orders: 120, revenue: 50000 },
  // { latLng: [-41.2865, 174.7762], name: "Smith Beverage Outlet", territory: "Central", orders: 95, revenue: 40000 },
  // { latLng: [-36.8790, 174.7325], name: "605 Morningside Drinkery", territory: "Northern", orders: 85, revenue: 36000 },
  // { latLng: [-36.8983, 174.7076], name: "AA Liquor Mt Albert", territory: "Northern", orders: 110, revenue: 45000 },
  // { latLng: [-43.8060, 172.9680], name: "ACD Tasting House", territory: "Southern", orders: 75, revenue: 32000 },
  // { latLng: [-39.6596, 176.8770], name: "Advintage Ltd", territory: "Central", orders: 98, revenue: 42000 },
  // { latLng: [-43.8060, 172.9680], name: "Aihe", territory: "Southern", orders: 80, revenue: 33000 },
  // { latLng: [-43.5230, 172.6120], name: "Aikmans Bar and Eatery", territory: "Southern", orders: 105, revenue: 47000 },
  // { latLng: [-43.8060, 172.9680], name: "Akaroa Bowls Club", territory: "Southern", orders: 65, revenue: 27000 },
  // { latLng: [-36.7237, 174.7098], name: "Albany Wine and Spirits", territory: "Northern", orders: 115, revenue: 49000 },
  // { latLng: [-44.6998, 169.1335], name: "Alchemy", territory: "Southern", orders: 70, revenue: 31000 },
  // { latLng: [-43.9036, 171.7497], name: "Allenton Liquor", territory: "Southern", orders: 90, revenue: 37000 },
  // { latLng: [-36.8456, 174.7680], name: "Alma Restaurant", territory: "Northern", orders: 100, revenue: 41000 },
  // { latLng: [-36.8456, 174.7680], name: "Amano", territory: "Northern", orders: 102, revenue: 41500 },
  // { latLng: [-43.5346, 172.6337], name: "Amazonita", territory: "Southern", orders: 88, revenue: 35000 },
  // { latLng: [-41.0874, 175.4550], name: "Aperitif", territory: "Central", orders: 77, revenue: 30000 },
  // { latLng: [-43.6020, 172.7130], name: "Arbour Woodfired Pizza", territory: "Southern", orders: 92, revenue: 38000 },
  // { latLng: [-44.9385, 168.8358], name: "Arrowtown Golf Club", territory: "Southern", orders: 68, revenue: 28000 },
  // { latLng: [-44.9385, 168.8358], name: "Arrowtown Wine Store", territory: "Southern", orders: 72, revenue: 29000 },
  // { latLng: [-40.3000, 175.7467], name: "Ash Liquor", territory: "Central", orders: 83, revenue: 34000 }
];

const categories = [
  { id: "wine", name: "Wine" },
  { id: "rtd", name: "RTD" },
  { id: "cocktails", name: "Cocktails" },
  { id: "cider", name: "Cider" },
  { id: "mead", name: "Mead" },
  { id: "spirits", name: "Spirits" },
  { id: "bitters", name: "Bitters" },
  { id: "non_alc", name: "Non-Alc" }
];

const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];


// Normalize helpers for reliable matching of category/brand names from API vs UI labels
const norm = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '') // strip diacritics
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '');
// Categories often differ by pluralization (e.g., Spirits vs Spirit). Trim a trailing 's'.
const normCat = (s) => {
  let n = norm(s);
  if (n.endsWith('s')) n = n.slice(0, -1);
  return n;
};

const priorYearColor = "#F3BB45";

const hasPriorValues = (values) =>
  Array.isArray(values) && values.some(value => Number(value || 0) !== 0);

const withPriorYearDataset = (chartData, priorValues, label = "Prior FY") => {
  if (!hasPriorValues(priorValues)) return chartData;

  return {
    ...chartData,
    datasets: [
      ...(chartData.datasets || []),
      {
        type: "line",
        label,
        data: priorValues,
        borderColor: priorYearColor,
        backgroundColor: priorYearColor,
        borderWidth: 3,
        pointRadius: 2,
        pointHoverRadius: 4,
        fill: false,
        tension: 0.35,
      },
    ],
  };
};

const withoutChartLegend = (options) => {
  return {
    ...options,
    plugins: {
      ...(options?.plugins || {}),
      legend: {
        ...(options?.plugins?.legend || {}),
        display: false,
      },
    },
  };
};

const selectedValuesCsv = (values, pickValue = item => item.value) => {
  const picked = (values || [])
    .map(pickValue)
    .filter(value => value != null && value !== "");
  return picked.length ? picked.join(",") : undefined;
};

const calendarYearForFyMonth = (fyEndYear, monthNum) =>
  monthNum >= 4 ? fyEndYear - 1 : fyEndYear;

const getMonthDayLimit = (fyEndYear, monthValue) => {
  const monthNum = parseInt(monthValue, 10);
  const dataYear = calendarYearForFyMonth(fyEndYear, monthNum);
  const today = new Date();
  const isCurrent = dataYear === today.getFullYear() && monthNum === (today.getMonth() + 1);
  return isCurrent
    ? today.getDate()
    : new Date(dataYear, monthNum, 0).getDate();
};

const SELECT_ALL_VALUE = "__select_all__";
const SELECT_ALL_OPTION = { value: SELECT_ALL_VALUE, label: "Select All" };

const dashboardFilterOptionStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const dashboardFilterCheckboxStyle = {
  margin: 0,
  flex: "0 0 auto",
};

const dashboardFilterValueBaseStyle = {
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const getOptionValueKey = (value) => String(value ?? "");

const areAllOptionsSelected = (selected, options) => {
  if (!Array.isArray(options) || options.length === 0) return false;

  const selectedKeys = new Set(
    (selected || []).map(option => getOptionValueKey(option.value))
  );

  return options.every(option => selectedKeys.has(getOptionValueKey(option.value)));
};

const stripSelectAllOption = (options) =>
  (options || []).filter(option => option.value !== SELECT_ALL_VALUE);

const CheckboxOption = (props) => {
  const rawOptions = props.selectProps.rawOptions || [];
  const selected = props.selectProps.value || [];
  const allSelected = areAllOptionsSelected(selected, rawOptions);
  const isSelectAll = props.data.value === SELECT_ALL_VALUE;
  const checked = isSelectAll ? allSelected : props.isSelected;
  const label = isSelectAll && allSelected ? "Clear All" : props.label;

  return (
    <components.Option {...props}>
      <span style={dashboardFilterOptionStyle}>
        <input
          type="checkbox"
          checked={checked}
          readOnly
          tabIndex={-1}
          style={dashboardFilterCheckboxStyle}
        />
        <span>{label}</span>
      </span>
    </components.Option>
  );
};

const CheckboxValueContainer = ({ children, ...props }) => {
  const selected = props.getValue();
  const rawOptions = props.selectProps.rawOptions || [];
  const selectedCount = selected.length;
  const childArray = React.Children.toArray(children);
  const input = childArray[childArray.length - 1];

  let label = props.selectProps.placeholder;
  if (selectedCount === 1) {
    label = selected[0].label;
  } else if (selectedCount > 1) {
    label = areAllOptionsSelected(selected, rawOptions)
      ? "All selected"
      : `${selectedCount} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      <span
        style={{
          ...dashboardFilterValueBaseStyle,
          color: selectedCount > 0 ? "#444" : "#b3b3b3",
        }}
      >
        {label}
      </span>
      {input}
    </components.ValueContainer>
  );
};

const checkboxSelectComponents = {
  Option: CheckboxOption,
  ValueContainer: CheckboxValueContainer,
};

function CheckboxMultiSelect({ id, options, value, onChange, placeholder }) {
  const safeOptions = Array.isArray(options) ? options : [];
  const safeValue = Array.isArray(value) ? value : [];
  const allSelected = areAllOptionsSelected(safeValue, safeOptions);

  const handleChange = (nextValue, actionMeta) => {
    if (actionMeta?.option?.value === SELECT_ALL_VALUE) {
      onChange(allSelected ? [] : safeOptions);
      return;
    }

    onChange(stripSelectAllOption(nextValue));
  };

  return (
    <Select
      id={id}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={[SELECT_ALL_OPTION, ...safeOptions]}
      rawOptions={safeOptions}
      value={safeValue}
      onChange={handleChange}
      placeholder={placeholder}
      components={checkboxSelectComponents}
    />
  );
}


// Helper function to get initials from a name
const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '??';
  const nameParts = name.trim().split(' ').filter(part => part.length > 0);
  if (nameParts.length === 0) return '??';
  
  let initials = nameParts[0].charAt(0);
  if (nameParts.length > 1) {
    initials += nameParts[nameParts.length - 1].charAt(0);
  } else if (nameParts[0].length > 1 && nameParts[0].charAt(1) !== ' ') { // Ensure second char is not space
    initials += nameParts[0].charAt(1); 
  }
  return initials.toUpperCase();
};


function Dashboard() {
  const navigate = useNavigate();
  const { data, setData } = useContext(DataContext);
  const products = data.products || []; // Ensure products is available for getNormalizedItems
  const dashboardData = data.dashboard || {};
  const [yearLoading, setYearLoading] = useState(false);
  const [priorYearComparison, setPriorYearComparison] = useState({ comparisons: {} });
  const [priorYearComparisonLoading, setPriorYearComparisonLoading] = useState(false);
  // console.log("Dashboard data:", dashboardData);
  // State for the new order modal
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [isDashboardOrderModalOpen, setIsDashboardOrderModalOpen] = useState(false);
  const [dashboardOrderDetails, setDashboardOrderDetails] = useState(null);
  const [loadingDashboardOrder, setLoadingDashboardOrder] = useState(false);
  const [confirmEditOrderOpen, setConfirmEditOrderOpen] = useState(false);
  const [confirmDeleteOrderOpen, setConfirmDeleteOrderOpen] = useState(false);
  const [deletingOrder, setDeletingOrder] = useState(false);
  const [editOrderModalOpen, setEditOrderModalOpen] = useState(false);
  const [orderBeingEdited, setOrderBeingEdited] = useState(null);

  // Helper function to normalize order items
  const getNormalizedItems = (order) => {
    if (!order) return [];
    const rawItems = order.items ?? order.orderItems ?? []; // Prefer order.items, fallback to order.orderItems
    if (!Array.isArray(rawItems)) return [];

    return rawItems.map(item => {
      const productDetails = products.find(p => p.id === item.productId) || {};
      const name = item.name || productDetails.name || "(unknown)";

      const quantity = parseInt(item.quantity || 0, 10);
      const bonusQuantity = parseInt(item.bonusQuantity || 0, 10);

      // Determine unit price in cents
      let unitPriceInCents = 0;
      if (item.bespokePriceCents != null) { // Check for bespoke price first
        unitPriceInCents = parseInt(item.bespokePriceCents, 10);
      } else if (item.unitPriceCents != null) { // Fallback to unit price
        unitPriceInCents = parseInt(item.unitPriceCents, 10);
      } else if (item.price != null) { // Fallback if cents fields are missing but a dollar price field exists
        unitPriceInCents = Math.round(parseFloat(item.price) * 100);
      }

      // Determine total price in cents for the line item
      let totalItemPriceInCents = 0;
      if (item.totalPriceCents != null) { // Check for total price in cents
        totalItemPriceInCents = parseInt(item.totalPriceCents, 10);
      } else if (item.total != null) { // Fallback if cents field is missing but a dollar total field exists
        totalItemPriceInCents = Math.round(parseFloat(item.total) * 100);
      } else { // Calculate if no total is provided
        totalItemPriceInCents = unitPriceInCents * quantity;
      }

      return {
        ...item, // Spread original item properties
        name,
        price: parseFloat((unitPriceInCents / 100).toFixed(2)), // Unit price in dollars
        total: parseFloat((totalItemPriceInCents / 100).toFixed(2)), // Line total in dollars
        quantity,
        bonusQuantity
      };
    });
  };



  const toggleDashboardOrderModal = () => {
    setIsDashboardOrderModalOpen(!isDashboardOrderModalOpen);
    if (isDashboardOrderModalOpen) { // If closing
      setSelectedOrderDetails(null);
    }
  };

  const toggleEditOrderModal = () => {
    if (editOrderModalOpen) {
      setOrderBeingEdited(null);
    }
    setEditOrderModalOpen(!editOrderModalOpen);
  };

  const handleOpenEditConfirm = () => {
    setConfirmEditOrderOpen(true);
  };

  const handleCancelEditOrder = () => {
    setConfirmEditOrderOpen(false);
  };

  const handleConfirmEditOrder = () => {
    if (!dashboardOrderDetails) return;

    setConfirmEditOrderOpen(false);
    setOrderBeingEdited(dashboardOrderDetails);
    setIsDashboardOrderModalOpen(false);
    setEditOrderModalOpen(true);
  };

  const handleDashboardOrderSave = (updatedOrder) => {
    const updatedCustomers = syncOrderIntoCustomers(data.customers || [], updatedOrder);
    setData((prev) => ({
      ...prev,
      customers: updatedCustomers,
    }));
    setEditOrderModalOpen(false);
    setOrderBeingEdited(null);
    setSelectedOrderDetails(null);
    setDashboardOrderDetails(null);
  };

  const handleOpenDeleteConfirm = () => {
    setConfirmDeleteOrderOpen(true);
  };

  const handleCancelDeleteOrder = () => {
    setConfirmDeleteOrderOpen(false);
  };

  const handleConfirmDeleteOrder = async () => {
    if (!selectedOrderDetails?.orderId) return;

    try {
      setDeletingOrder(true);
      await deleteOrder(selectedOrderDetails.orderId);

      const updatedCustomers = (data.customers || []).map((customer) => ({
        ...customer,
        orderHistory: (customer.orderHistory || []).filter(
          (order) => order.orderId !== selectedOrderDetails.orderId
        ),
      }));

      setData((prev) => ({
        ...prev,
        customers: updatedCustomers,
      }));

      setConfirmDeleteOrderOpen(false);
      setIsDashboardOrderModalOpen(false);
      setSelectedOrderDetails(null);
      setDashboardOrderDetails(null);
    } catch (err) {
      console.error("Failed to delete order:", err);
    } finally {
      setDeletingOrder(false);
    }
  };

const handleDashboardOrderClick = async (order) => {
  setSelectedOrderDetails(order);
  setIsDashboardOrderModalOpen(true);
  setDashboardOrderDetails(null);
  setLoadingDashboardOrder(true);

  try {
    const details = await getOrderDetails(order.orderId);
    setDashboardOrderDetails(details);
  } catch (err) {
    console.error("Failed to load dashboard order:", err);
  } finally {
    setLoadingDashboardOrder(false);
  }
};
  // Compile all orders from all customers
  const allOrders = useMemo(() => {
    // console.log("customer", data.orders);
    if (!data.customers) return [];
    return data.customers.reduce((acc, customer) => {
      const customerOrders = (customer.orderHistory || []).map(order => ({
        ...order,
        customerName: customer.businessName,
        customerId: customer.id
      }));
      return acc.concat(customerOrders);
    }, []);
  }, [data.customers]);

  // Filter state declarations
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedTerritories, setSelectedTerritories] = useState([]);

  // Get, for example, the 5 most recent orders
  const recentOrders = useMemo(() => {
    if (!allOrders || allOrders.length === 0) return []; // Guard against undefined or empty allOrders
    return allOrders
      .sort((a, b) => {
        const dateA = new Date(getOrderActivityTimestamp(a) || 0);
        const dateB = new Date(getOrderActivityTimestamp(b) || 0);
        if (dateB - dateA !== 0) return dateB - dateA;
        return Number(b.orderId) - Number(a.orderId);
      })
      .slice(0, 20);
  }, [allOrders]);

  // Memoized calculation for items in the modal
  const detailItemsForModal = useMemo(() => {
    // Ensure getNormalizedItems, selectedOrderDetails, and products are defined and in scope
    if (!selectedOrderDetails) return []; // Add guard for selectedOrderDetails
    return getNormalizedItems(selectedOrderDetails);
  }, [selectedOrderDetails, products, getNormalizedItems]); // Added getNormalizedItems to dependencies if it's defined inside Dashboard

  const initialTasksData = data.tasks || [];
  const brands = data.brands || [];
  const userProfile = data.userProfile || {};
  const canEditOrderEntries = canEditOrders(userProfile.email);
  const isSales = userProfile.role === "sales";
  // const salesReps = data.users || [];
  // console.log("Sales reps:", salesReps);
  const today    = new Date();
  const calYear  = today.getFullYear();
  const calMonth = today.getMonth() + 1; // 1–12
  const fyEndYear = calMonth >= 4 ? calYear + 1 : calYear;
  const [selectedYear, setSelectedYear] = useState(fyEndYear.toString());
  const yearOptions = useMemo(() => {
    const yrs = [];
    for (let i = 0; i < 10; i++) {
      yrs.push((fyEndYear - i).toString());
    }
    return yrs;
  }, [fyEndYear]);

  // Fetch dashboard data when the selected year changes (always hit backend with the year)
  useEffect(() => {
    const sub = data.userProfile?.sub;
    if (!sub) return;
    if (!selectedYear) return; // skip "All"

    let cancelled = false;
    (async () => {
      try {
        setYearLoading(true);
        const { territories, topCustomers } = await fetchDashboardYearParts({
          yearEnd: selectedYear,
          sub,
        });
        const yearBlock = buildDashboardYearBlockFromTerritories(territories);

        if (!cancelled) {
          setData(prev => ({
            ...prev,
            dashboard: {
              ...prev.dashboard,
              [selectedYear]: {
                ...yearBlock,
                topCustomers,
              }
            }
          }));
        }
      } catch (err) {
        console.error("Dashboard year fetch error:", err);
      } finally {
        if (!cancelled) setYearLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [selectedYear, data.userProfile?.sub, setData]);

  // Display helper: format FY labels like FY25/26 for 2026
  const formatFYLabel = (yearEndStr) => {
    const end = parseInt(yearEndStr, 10);
    if (!Number.isFinite(end)) return yearEndStr;
    const startShort = String((end - 1) % 100).padStart(2, '0');
    const endShort   = String(end % 100).padStart(2, '0');
    return `FY${startShort}/${endShort}`;
  };

  // assuming your dashboardData[selectedYear].territories is an array of { territory: 'North', dailyData: [...] }
const territoryOptions = useMemo(() => {
  const yearInfo = dashboardData[selectedYear] || {};
  const allTerritories = data.territories || [];

  return (yearInfo.territories || []).map(t => {
    // t.territory is the ID
    const territoryObj = allTerritories.find(tt => tt.id === t.territory);

    return {
      value: t.territory,
      label: territoryObj
        ? territoryObj.name            // the human name from context
        : t.territory                  // fallback to the ID
    };
  });
}, [
  dashboardData,
  selectedYear,
  // make sure to re-run when your master territory list changes:
  data.territories
]);
  const categoryOptions = useMemo(
    () => categories.map(c => ({ value: c.id, label: c.name })),
    []
  );
  const brandOptions = useMemo(
    () => brands
      .filter(b => !b.is_archived)
      .map(b => ({ value: b.id, label: b.name })),
    [brands]
  );
  const yearInfo     = dashboardData[selectedYear] || {};
  const topCustomers = yearInfo.topCustomers || [];
  
  const monthNumberToName = useMemo(() => months.reduce((acc, m) => ({...acc, [m.value]: m.label}), {}), []);

  const brandIdToName = useMemo(() => {
    if (!brands || brands.length === 0) return {};
    return brands.reduce((acc, brand) => {
      acc[brand.id] = brand.name;
      return acc;
    }, {});
  }, [brands]);
  

  // const [selectedRep, setSelectedRep] = useState([]);
  const [showHashColumn, setShowHashColumn] = useState(window.innerWidth >= 1050);
  const [showTerritoryColumn, setShowTerritoryColumn] = useState(window.innerWidth >= 400);
  
  const [territorySortField, setTerritorySortField] = useState('territory');
  const [territorySortDirection, setTerritorySortDirection] = useState('asc');

  const handleTerritorySort = (field) => {
    if (territorySortField === field) {
      setTerritorySortDirection(territorySortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setTerritorySortField(field);
      setTerritorySortDirection('asc');
    }
  };

  const formatRevenue = (revenue) => {
    return `$${revenue.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  };
  const formatCaseQuantity = (value) => {
    const numericValue = Number(value || 0);
    const hasFraction = Math.abs(numericValue % 1) > 0.0001;
    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits: hasFraction ? 1 : 0,
      maximumFractionDigits: 2,
    });
  };

const filteredRawDailyData = useMemo(() => {
  const yearData = dashboardData[selectedYear] || {};

  // Build selected territory set (if any)
  const picks = new Set((selectedTerritories || []).map(t => t.value));

  // Use territory buckets (all if none selected) so we can aggregate categories/brands even without a territory filter
  const territories = Array.isArray(yearData.territories) ? yearData.territories : [];
  const territoryBuckets = picks.size > 0
    ? territories.filter(t => picks.has(t.territory))
    : territories;

  // Flatten day rows from selected territories
  let days = territoryBuckets.flatMap(t => t.dailyData || []);

  // Fallback: if no territory data is available, use normalized daily totals (without category/brand breakdown)
  if (days.length === 0) {
    const normalized = Array.isArray(yearData.daily) ? yearData.daily : [];
    return normalized.map(d => ({
      date: d.date,
      totalRevenue: d.totalRevenue || "0",
      totalOrders:  d.totalOrders  || "0",
      totalCases:   d.totalCases   || "0",
      categories:   {},
      brands:       {}
    }));
  }

  // Merge entries by date (including orders, revenue, cases, and nested categories/brands)
  const mergedByDate = days.reduce((acc, day) => {
    if (!acc[day.date]) {
      acc[day.date] = {
        date: day.date,
        totalRevenue: day.totalRevenue || "0",
        totalOrders:  day.totalOrders  || "0",
        totalCases:   day.totalCases   || "0",
        categories:   {},
        brands:       {}
      };
    }

    const e = acc[day.date];

    // sum top-level totals
    e.totalRevenue = (
      parseFloat(e.totalRevenue) +
      parseFloat(day.totalRevenue || 0)
    ).toString();
    e.totalOrders = (
      parseInt(e.totalOrders, 10) +
      parseInt(day.totalOrders  || 0, 10)
    ).toString();
    e.totalCases = (
      Number(e.totalCases || 0) +
      Number(day.totalCases || 0)
    ).toString();

    // merge categories (orders + revenue + cases, and nested brands)
    if (day.categories) {
      for (const cat of Object.keys(day.categories)) {
        const srcCat = day.categories[cat] || {};
        const srcCatOrders = Number(srcCat.orders || 0);
        const srcCatRevenue = Number(srcCat.revenue || 0);
        const srcCatCases = Number(srcCat.cases || 0);
        e.categories[cat] = e.categories[cat] || { orders: 0, revenue: 0, brands: {} };
        e.categories[cat].orders  += srcCatOrders;
        e.categories[cat].revenue += srcCatRevenue;
        e.categories[cat].cases = Number(e.categories[cat].cases || 0) + srcCatCases;

        if (srcCat.brands) {
          for (const b of Object.keys(srcCat.brands)) {
            const srcBrand = srcCat.brands[b] || {};
            const srcBrandOrders = Number(srcBrand.orders || 0);
            const srcBrandRevenue = Number(srcBrand.revenue || 0);
            const srcBrandCases = Number(srcBrand.cases || 0);
            e.categories[cat].brands[b] = e.categories[cat].brands[b] || { orders: 0, revenue: 0 };
            e.categories[cat].brands[b].orders  += srcBrandOrders;
            e.categories[cat].brands[b].revenue += srcBrandRevenue;
            e.categories[cat].brands[b].cases = Number(e.categories[cat].brands[b].cases || 0) + srcBrandCases;
          }
        }
      }
    }

    // merge root brands (orders + revenue + cases)
    if (day.brands) {
      for (const b of Object.keys(day.brands)) {
        const srcBrand = day.brands[b] || {};
        const srcOrders = Number(srcBrand.orders || 0);
        const srcRevenue = Number(srcBrand.revenue || 0);
        const srcCases = Number(srcBrand.cases || 0);
        e.brands[b] = e.brands[b] || { orders: 0, revenue: 0 };
        e.brands[b].orders  += srcOrders;
        e.brands[b].revenue += srcRevenue;
        e.brands[b].cases = Number(e.brands[b].cases || 0) + srcCases;
      }
    }

    return acc;
  }, {});

  return Object.values(mergedByDate);
}, [dashboardData, selectedYear, selectedTerritories]);

const normalizedTerritoryDaily = useMemo(() => {
  const yearInfo = dashboardData[selectedYear] || {};
  const normalizedDailyRows = Array.isArray(yearInfo.daily)
    ? yearInfo.daily
    : [];
  const territoryRows = Array.isArray(yearInfo.territories)
    ? yearInfo.territories.flatMap(t =>
        (t.dailyData || []).map(dd => ({
          ...dd,
          territory: t.territory,
        }))
      )
    : [];

  let rows = normalizedDailyRows.length > 0 ? normalizedDailyRows : territoryRows;
  if (!rows.length) return [];

  const selectedIds = new Set((selectedTerritories || []).map(t => String(t.value)));

  const filterRows = (sourceRows) =>
    sourceRows
      .filter(row => row && row.date)
      .filter(row => {
        if (selectedIds.size === 0) return true;
        if (row.territory == null) return false;
        return selectedIds.has(String(row.territory));
      });

  let filtered = filterRows(rows);

  if (filtered.length === 0 && selectedIds.size > 0 && territoryRows.length > 0) {
    filtered = filterRows(territoryRows);
  }

  return filtered;
}, [dashboardData, selectedYear, selectedTerritories]);

const normalizedDailyTotals = useMemo(() => {
  if (!normalizedTerritoryDaily.length) return [];

  const byDate = {};

  normalizedTerritoryDaily.forEach(row => {
    const key = row.date;
    if (!key) return;

    if (!byDate[key]) {
      byDate[key] = { date: key, revenue: 0, orders: 0, cases: 0 };
    }

    const revenue = Number(row.totalRevenue ?? row.revenue ?? 0) || 0;
    const orders = Number(row.totalOrders ?? row.orders ?? 0) || 0;
    const cases = Number(row.totalCases ?? row.cases ?? 0) || 0;

    byDate[key].revenue += revenue;
    byDate[key].orders += orders;
    byDate[key].cases += cases;
  });

  return Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date));
}, [normalizedTerritoryDaily]);

  const baseFilteredData = useMemo(() => {
    const hasCatFilter = selectedCategory && selectedCategory.length > 0;
    const hasBrandFilter = selectedBrand && selectedBrand.length > 0;

    // When no category/brand filters are active and normalized data exists,
    // reuse the backend-normalized totals to keep parity with Revenue Achieved.
    if (!hasCatFilter && !hasBrandFilter && normalizedDailyTotals.length > 0) {
      return normalizedDailyTotals.map(day => ({
        date: day.date,
        revenue: Number(day.revenue || 0),
        orders: Number(day.orders || 0),
        cases: Number(day.cases || 0),
      }));
    }

    const dailyData = filteredRawDailyData;
    if (!dailyData) {
      return [];
    }

    const hasBoth = hasCatFilter && hasBrandFilter;
    const selectedCategoryNorms = hasCatFilter
      ? selectedCategory.map(c => normCat(c.label))
      : [];
    const selectedBrandNorms = hasBrandFilter
      ? selectedBrand.map(b => brandIdToName[b.value]).filter(Boolean).map(norm)
      : [];

    return dailyData.map(day => {
      let revenue = 0;
      let orders = 0;
      let cases = 0;

      // Build quick-lookup maps for this day's category and brand keys
      const dayCatKeyMap = {};
      Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
      const dayBrandKeyMap = {};
      Object.keys(day.brands || {}).forEach(k => { dayBrandKeyMap[norm(k)] = k; });

      if (hasBoth) {
        // Intersect category and brand using nested category.brand buckets
        for (const catNorm of selectedCategoryNorms) {
          const catKey = dayCatKeyMap[catNorm];
          const catData = catKey ? day.categories?.[catKey] : undefined;
          if (catData && catData.brands) {
            const catBrandKeyMap = {};
            Object.keys(catData.brands || {}).forEach(k => { catBrandKeyMap[norm(k)] = k; });
            for (const brandNorm of selectedBrandNorms) {
              const bKey = catBrandKeyMap[brandNorm];
              const bd = bKey ? catData.brands[bKey] : undefined;
              if (bd) {
                revenue += (bd.revenue || 0) / 100;
                orders  += Number(bd.orders || 0);
                cases   += Number(bd.cases || 0);
              }
            }
          }
        }
      } else if (hasCatFilter) {
        // revenue and orders from selected categories only
        for (const catNorm of selectedCategoryNorms) {
          const catKey = dayCatKeyMap[catNorm];
          const catData = catKey ? day.categories?.[catKey] : undefined;
          if (catData) {
            revenue += (catData.revenue || 0) / 100;
            orders  += Number(catData.orders || 0);
            cases   += Number(catData.cases || 0);
          }
        }
      } else if (hasBrandFilter) {
        // revenue and orders from selected brands only
        for (const brandNorm of selectedBrandNorms) {
          const bKey = dayBrandKeyMap[brandNorm];
          const bData = bKey ? day.brands?.[bKey] : undefined;
          if (bData) {
            revenue += (bData.revenue || 0) / 100;
            orders  += Number(bData.orders || 0);
            cases   += Number(bData.cases || 0);
          }
        }
      } else {
        revenue = parseFloat(day.totalRevenue);
        orders  = parseInt(day.totalOrders, 10);
        cases   = Number(day.totalCases || 0);
      }
      
      // Keep the day if we have either revenue or orders for the selection
      if (revenue > 0 || orders > 0) {
        return {
          date: day.date,
          revenue,
          orders,
          cases,
        };
      }
      return null;
    }).filter(Boolean);
  }, [filteredRawDailyData, selectedCategory, selectedBrand, brandIdToName, normalizedDailyTotals]);

  // Build a consistent daily time series from territory buckets when any filter is active,
  // to keep charts aligned with Monthly Sales by Territory and avoid double counting.
  const chartDailySeries = useMemo(() => {
    const hasCatFilter = selectedCategory && selectedCategory.length > 0;
    const hasBrandFilter = selectedBrand && selectedBrand.length > 0;

    // If only territory/month filters are active, the normalized base data already matches Revenue Achieved.
    if (!hasCatFilter && !hasBrandFilter) {
      return baseFilteredData;
    }

    const hasTerritoryFilter = selectedTerritories && selectedTerritories.length > 0;
    const yearInfo = dashboardData[selectedYear] || {};
  const selectedCategoryNorms = hasCatFilter ? selectedCategory.map(c => normCat(c.label)) : [];
  const selectedBrandNorms = hasBrandFilter ? selectedBrand.map(b => brandIdToName[b.value]).filter(Boolean).map(norm) : [];
    const pickedTerritoryIds = hasTerritoryFilter ? selectedTerritories.map(t => t.value) : [];

    const territoryBuckets = (yearInfo.territories || [])
      .filter(t => pickedTerritoryIds.length === 0 || pickedTerritoryIds.includes(t.territory));

    const byDate = {};

    territoryBuckets.forEach(t => {
      (t.dailyData || []).forEach(day => {
        let rev = 0;
        let ord = 0;
        let cas = 0;

        if (hasCatFilter && hasBrandFilter) {
          const dayCatKeyMap = {};
          Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
          selectedCategoryNorms.forEach(catNorm => {
            const catKey = dayCatKeyMap[catNorm];
            const catData = catKey ? day.categories?.[catKey] : undefined;
            if (catData && catData.brands) {
              const catBrandKeyMap = {};
              Object.keys(catData.brands || {}).forEach(k => { catBrandKeyMap[norm(k)] = k; });
              selectedBrandNorms.forEach(brandNorm => {
                const bKey = catBrandKeyMap[brandNorm];
                const bd = bKey ? catData.brands[bKey] : undefined;
                if (bd) {
                  rev += (bd.revenue || 0) / 100;
                  ord += Number(bd.orders || 0);
                  cas += Number(bd.cases || 0);
                }
              });
            }
          });
        } else if (hasCatFilter) {
          const dayCatKeyMap = {};
          Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
          selectedCategoryNorms.forEach(catNorm => {
            const catKey = dayCatKeyMap[catNorm];
            const catData = catKey ? day.categories?.[catKey] : undefined;
            if (catData) {
              rev += (catData.revenue || 0) / 100;
              ord += Number(catData.orders || 0);
              cas += Number(catData.cases || 0);
            }
          });
        } else if (hasBrandFilter) {
          const dayBrandKeyMap = {};
          Object.keys(day.brands || {}).forEach(k => { dayBrandKeyMap[norm(k)] = k; });
          selectedBrandNorms.forEach(brandNorm => {
            const bKey = dayBrandKeyMap[brandNorm];
            const bd = bKey ? day.brands?.[bKey] : undefined;
            if (bd) {
              rev += (bd.revenue || 0) / 100;
              ord += Number(bd.orders || 0);
              cas += Number(bd.cases || 0);
            }
          });
        } else {
          rev = parseFloat(day.totalRevenue || 0);
          ord = parseInt(day.totalOrders || 0, 10);
          cas = Number(day.totalCases || 0);
        }

        if (!byDate[day.date]) {
          byDate[day.date] = { date: day.date, revenue: 0, orders: 0, cases: 0 };
        }
        byDate[day.date].revenue += rev;
        byDate[day.date].orders  += ord;
        byDate[day.date].cases   += cas; // sum filtered cases if provided
      });
    });

    return Object.values(byDate).sort((a,b) => a.date.localeCompare(b.date));
  }, [baseFilteredData, dashboardData, selectedYear, selectedTerritories, selectedCategory, selectedBrand, brandIdToName]);

  const filteredDailyData = useMemo(() => {
    if (!selectedMonths || selectedMonths.length === 0) {
      return baseFilteredData;
    }
    const selectedMonthValues = selectedMonths.map(m => m.value);
    return baseFilteredData.filter(d => selectedMonthValues.includes(d.date.substring(5, 7)));
  }, [baseFilteredData, selectedMonths]);

  // State for async top customers calculation
  const [displayedTopCustomers, setDisplayedTopCustomers] = useState([]);
  const [loadingTopCustomers, setLoadingTopCustomers] = useState(false);

  // Effect to calculate top customers with API calls for order details
  useEffect(() => {
    const calculateTopCustomers = async () => {
      const hasCategoryFilter = selectedCategory && selectedCategory.length > 0;
      const hasBrandFilter = selectedBrand && selectedBrand.length > 0;
      const hasTerritoryFilter = selectedTerritories && selectedTerritories.length > 0;
      const hasMonthFilter = selectedMonths && selectedMonths.length > 0;

      const yearInfo = dashboardData[selectedYear] || {};
      const customers = data.customers || [];
      const allTerritories = data.territories || []; // Master territory list for ID-to-name mapping

      // Map territory ID <-> name
      const territoryIdToName = {};
      allTerritories.forEach(t => { territoryIdToName[t.id] = t.name; });

      // Use precomputed only when NO filters are active (brand, category, territory, or month)
      if (!hasCategoryFilter && !hasBrandFilter && !hasTerritoryFilter && !hasMonthFilter) {
        setDisplayedTopCustomers(topCustomers);
        setLoadingTopCustomers(false);
        return;
      }

      // Otherwise compute for current filters
      setLoadingTopCustomers(true);

      try {
        const selectedCategoryNames = hasCategoryFilter ? selectedCategory.map(c => c.label) : [];
        const selectedBrandIds = hasBrandFilter ? new Set(selectedBrand.map(b => b.value)) : new Set();
        const selectedBrandNames = hasBrandFilter
          ? selectedBrand.map(b => brandIdToName[b.value]).filter(Boolean)
          : [];
        const selectedTerritoryIds = hasTerritoryFilter ? new Set(selectedTerritories.map(t => t.value)) : null;
        const selectedMonthValues = hasMonthFilter ? selectedMonths.map(m => m.value) : null;

        // Helper: FY check
        const inSelectedFY = (dateISO) => {
          if (!dateISO) return false;
          const fyEnd = parseInt(selectedYear, 10);
          const fyStart = fyEnd - 1;
          const y = parseInt(dateISO.substring(0, 4), 10);
          const m = parseInt(dateISO.substring(5, 7), 10);
          if (y === fyStart && m >= 4) return true; // Apr–Dec of start year
          if (y === fyEnd && m <= 3) return true;   // Jan–Mar of end year
          return false;
        };

        // Helper: month filter check
        const monthAllowed = (dateISO) => {
          if (!selectedMonthValues) return true;
          const m = dateISO?.slice(5, 7);
          return selectedMonthValues.includes(m);
        };

        // Build set of allowed territory names based on selected territory IDs
        let allowedTerritoryNames = null;
        if (selectedTerritoryIds) {
          allowedTerritoryNames = new Set([
            ...((yearInfo.territories || [])
              .filter(t => selectedTerritoryIds.has(t.territory))
              .map(t => territoryIdToName[t.territory])
              .filter(Boolean))
          ]);
        }

        const customerAgg = {};

        if (hasCategoryFilter || hasBrandFilter) {
          // Detailed path using territory.dailyData and order item filtering
          const territoryBuckets = (yearInfo.territories || [])
            .filter(t => selectedTerritoryIds === null || selectedTerritoryIds.has(t.territory));

          for (const territory of territoryBuckets) {
            const days = territory.dailyData || [];
            const territoryName = territoryIdToName[territory.territory];

            // Preselect days that have matching brand/category and pass month filter
            const daysWithMatching = [];
            for (const day of days) {
              if (!monthAllowed(day.date)) continue;
              const dayOrders = parseInt(day.totalOrders, 10) || 0;
              if (dayOrders === 0) continue;

              let match = false;
              if (hasCategoryFilter) {
                for (const catName of selectedCategoryNames) {
                  const catData = day.categories?.[catName];
                  if (catData && catData.revenue > 0) { match = true; break; }
                }
              } else if (hasBrandFilter) {
                for (const brandName of selectedBrandNames) {
                  const bData = day.brands?.[brandName];
                  if (bData && bData.revenue > 0) { match = true; break; }
                }
              }
              if (match) daysWithMatching.push(day);
            }

            if (daysWithMatching.length === 0) continue;

            // Customers in this territory
            const territoryCustomers = customers.filter(c => !allowedTerritoryNames || allowedTerritoryNames.has(c.territory) ? c.territory === territoryName : c.territory === territoryName);

            for (const customer of territoryCustomers) {
              const orderHistory = customer.orderHistory || [];
              if (orderHistory.length === 0) continue;

              for (const order of orderHistory) {
                const orderDate = order.date?.substring(0, 10);
                if (!orderDate || !inSelectedFY(orderDate) || !monthAllowed(orderDate)) continue;
                // Check the day is one of our preselected matching days
                if (!daysWithMatching.find(d => d.date === orderDate)) continue;

                try {
                  const resp = await fetch(`${API_BASE}/order/${order.orderId}`);
                  if (!resp.ok) continue;
                  const orderDetails = await resp.json();
                  const items = orderDetails.items || orderDetails.orderItems || [];

                  let ordRev = 0;
                  for (const item of items) {
                    const product = products.find(p => p.id === item.productId);
                    if (!product) continue;

                    let matches = false;
                    if (hasCategoryFilter && hasBrandFilter) {
                      const productType = product.productType || product.category;
                      matches = selectedCategoryNames.includes(productType) && product.brand && selectedBrandIds.has(product.brand.id);
                    } else if (hasCategoryFilter) {
                      const productType = product.productType || product.category;
                      matches = selectedCategoryNames.includes(productType);
                    } else if (hasBrandFilter) {
                      matches = product.brand && selectedBrandIds.has(product.brand.id);
                    }

                    if (matches) {
                      const cents = (item.totalPriceCents != null)
                        ? Number(item.totalPriceCents)
                        : (item.unitPriceCents != null && item.quantity != null)
                          ? Number(item.unitPriceCents) * Number(item.quantity)
                          : 0;
                      ordRev += cents / 100;
                    }
                  }

                  if (ordRev > 0) {
                    if (!customerAgg[customer.id]) {
                      customerAgg[customer.id] = {
                        customerId: customer.id,
                        name: customer.businessName,
                        territory: customer.territory,
                        totalRevenue: 0,
                        totalOrders: 0,
                      };
                    }
                    customerAgg[customer.id].totalRevenue += ordRev;
                    customerAgg[customer.id].totalOrders += 1;
                  }
                } catch { /* ignore */ }
              }
            }
          }
        } else {
          // Territory-only or month-only filtering (no brand/category): compute per customer
          const allowedNames = allowedTerritoryNames || new Set((allTerritories || []).map(t => t.name));

          const territoryCustomers = customers.filter(c => allowedNames.has(c.territory));

          for (const customer of territoryCustomers) {
            const orderHistory = customer.orderHistory || [];
            if (orderHistory.length === 0) continue;

            for (const order of orderHistory) {
              const orderDate = order.date?.substring(0, 10);
              if (!orderDate || !inSelectedFY(orderDate) || !monthAllowed(orderDate)) continue;

              // Prefer order.total if present, else attempt fetch, else 0
              let ordRev = 0;
              if (order.total != null) {
                ordRev = Number(order.total) || 0;
              } else if (order.totalPriceCents != null) {
                ordRev = Number(order.totalPriceCents) / 100;
              } else {
                try {
                  const resp = await fetch(`${API_BASE}/order/${order.orderId}`);
                  if (resp.ok) {
                    const details = await resp.json();
                    const items = details.items || details.orderItems || [];
                    ordRev = items.reduce((sum, it) => {
                      const cents = (it.totalPriceCents != null)
                        ? Number(it.totalPriceCents)
                        : (it.unitPriceCents != null && it.quantity != null)
                          ? Number(it.unitPriceCents) * Number(it.quantity)
                          : 0;
                      return sum + cents;
                    }, 0) / 100;
                  }
                } catch { /* ignore */ }
              }

              if (ordRev > 0) {
                if (!customerAgg[customer.id]) {
                  customerAgg[customer.id] = {
                    customerId: customer.id,
                    name: customer.businessName,
                    territory: customer.territory,
                    totalRevenue: 0,
                    totalOrders: 0,
                  };
                }
                customerAgg[customer.id].totalRevenue += ordRev;
                customerAgg[customer.id].totalOrders += 1;
              }
            }
          }
        }

        const sorted = Object.values(customerAgg)
          .sort((a, b) => b.totalRevenue - a.totalRevenue)
          .slice(0, 20);
        setDisplayedTopCustomers(sorted);
      } catch (error) {
        console.error('Error calculating top customers:', error);
        setDisplayedTopCustomers([]);
      } finally {
        setLoadingTopCustomers(false);
      }
    };

    calculateTopCustomers();
  }, [topCustomers, selectedTerritories, selectedCategory, selectedBrand, selectedMonths, selectedYear, dashboardData, data.customers, products, brandIdToName]);

  const totalFilteredOrders = useMemo(() => {
    const hasCategoryFilter = selectedCategory && selectedCategory.length > 0;
    const hasBrandFilter = selectedBrand && selectedBrand.length > 0;
    const hasBoth = hasCategoryFilter && hasBrandFilter;
    const hasTerritoryFilter = selectedTerritories && selectedTerritories.length > 0;

    // If no filters at all (brand/category/territory/month), fall back to simple sum
    const noMonths = !selectedMonths || selectedMonths.length === 0;
    if (!hasCategoryFilter && !hasBrandFilter && !hasTerritoryFilter && noMonths) {
      return filteredDailyData.reduce((sum, day) => sum + day.orders, 0);
    }

    // Compute from territory buckets for consistency with Monthly Sales by Territory
    const yearInfo = dashboardData[selectedYear] || {};
  const selectedCategoryNorms = hasCategoryFilter ? selectedCategory.map(c => normCat(c.label)) : [];
  const selectedBrandNorms = hasBrandFilter ? selectedBrand.map(b => brandIdToName[b.value]).filter(Boolean).map(norm) : [];
    const pickedTerritoryIds = hasTerritoryFilter ? selectedTerritories.map(t => t.value) : [];

    const territoryBuckets = (yearInfo.territories || [])
      .filter(t => pickedTerritoryIds.length === 0 || pickedTerritoryIds.includes(t.territory));

    let totalOrders = 0;

    const selectedMonthValues = selectedMonths.length > 0 ? selectedMonths.map(m => m.value) : null;

    territoryBuckets.forEach(territory => {
      const days = territory.dailyData || [];

      days.forEach(day => {
        if (selectedMonthValues) {
          const dayMonth = day.date?.slice(5, 7);
          if (!selectedMonthValues.includes(dayMonth)) return;
        }

        if (hasBoth) {
          const dayCatKeyMap = {};
          Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
          selectedCategoryNorms.forEach(catNorm => {
            const catKey = dayCatKeyMap[catNorm];
            const catData = catKey ? day.categories?.[catKey] : undefined;
            if (catData && catData.brands) {
              const catBrandKeyMap = {};
              Object.keys(catData.brands || {}).forEach(k => { catBrandKeyMap[norm(k)] = k; });
              selectedBrandNorms.forEach(brandNorm => {
                const bKey = catBrandKeyMap[brandNorm];
                const bd = bKey ? catData.brands[bKey] : undefined;
                if (bd) totalOrders += Number(bd.orders || 0);
              });
            }
          });
        } else if (hasCategoryFilter) {
          const dayCatKeyMap = {};
          Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
          selectedCategoryNorms.forEach(catNorm => {
            const catKey = dayCatKeyMap[catNorm];
            const catData = catKey ? day.categories?.[catKey] : undefined;
            if (catData) totalOrders += Number(catData.orders || 0);
          });
        } else if (hasBrandFilter) {
          const dayBrandKeyMap = {};
          Object.keys(day.brands || {}).forEach(k => { dayBrandKeyMap[norm(k)] = k; });
          selectedBrandNorms.forEach(brandNorm => {
            const bKey = dayBrandKeyMap[brandNorm];
            const brandData = bKey ? day.brands?.[bKey] : undefined;
            if (brandData) totalOrders += Number(brandData.orders || 0);
          });
        } else {
          totalOrders += parseInt(day.totalOrders || 0, 10);
        }
      });
    });

    return totalOrders;
  }, [filteredDailyData, selectedCategory, selectedBrand, brandIdToName, dashboardData, selectedYear, selectedTerritories, selectedMonths]);

  const totalFilteredRevenue = useMemo(() => {
    const hasCategoryFilter = selectedCategory && selectedCategory.length > 0;
    const hasBrandFilter = selectedBrand && selectedBrand.length > 0;
    const monthSet = (selectedMonths && selectedMonths.length > 0)
      ? new Set(selectedMonths.map(m => m.value))
      : null;

    const sumSeries = (series, getValue) => {
      if (!Array.isArray(series) || series.length === 0) return 0;
      return series.reduce((sum, entry) => {
        if (!entry?.date) return sum;
        if (monthSet) {
          const entryMonth = entry.date.slice(5, 7);
          if (!monthSet.has(entryMonth)) return sum;
        }
        const value = Number(getValue(entry)) || 0;
        return sum + value;
      }, 0);
    };

    if (hasCategoryFilter || hasBrandFilter) {
      return sumSeries(chartDailySeries, d => d.revenue);
    }

    return sumSeries(
      normalizedTerritoryDaily,
      d => d.totalRevenue ?? d.revenue
    );
  }, [
    chartDailySeries,
    normalizedTerritoryDaily,
    selectedMonths,
    selectedCategory,
    selectedBrand
  ]);

const targetRevenue = useMemo(() => {
  const budgets = data.budgets || [];
  const year = parseInt(selectedYear, 10);
  if (!budgets.length || !year) return 0;

  // 1) Determine which territory IDs are “in play”
  //    - If you’ve explicitly filtered, use those.
  //    - Otherwise use every territory in this year's dashboardData.
  const availableTerrs = dashboardData[selectedYear]?.territories?.map(t => t.territory) || [];
  const terrFilter = selectedTerritories.length > 0
    ? selectedTerritories.map(t => parseInt(t.value, 10))
    : availableTerrs.map(id => parseInt(id, 10));

  // 2) Determine which months are “in play”
  //    - If you’ve explicitly filtered, use those.
  //    - Otherwise all 1–12.
  const monthFilter = selectedMonths.length > 0
    ? selectedMonths.map(m => {
        const monthValue = parseInt(m.value, 10);
        return monthValue >= 4 ? monthValue - 3 : monthValue + 9;
      })
    : Array.from({ length: 12 }, (_, i) => i + 1);

  // 3) Sum budgets matching year, territory_id ∈ terrFilter, month ∈ monthFilter
  const sum = budgets.reduce((sum, b) => {
    if (
      parseInt(b.year, 10) === year &&
      terrFilter.includes(b.territory_id) &&
      monthFilter.includes(parseInt(b.month, 10))
    ) {
      return sum + parseFloat(b.amount);
    }
    return sum;
  }, 0);

  return sum;
}, [
  data.budgets,
  dashboardData,
  selectedYear,
  selectedTerritories,
  selectedMonths
]);


  const percentageAchieved = useMemo(() => {
    if (targetRevenue === 0) return 0;
    return (totalFilteredRevenue / targetRevenue) * 100;
  }, [totalFilteredRevenue, targetRevenue]);

  const lastSelectedMonthValue = useMemo(() => {
    const today = new Date();
    return selectedMonths.length > 0
      ? selectedMonths[selectedMonths.length - 1].value
      : (today.getMonth() + 1).toString().padStart(2, '0');
  }, [selectedMonths]);

  const quarterEndMonthValue = useMemo(() => {
    const monthValues = selectedMonths.map(m => parseInt(m.value, 10));
    return monthValues.length > 0
      ? String(Math.max(...monthValues)).padStart(2, "0")
      : (new Date().getMonth() + 1).toString().padStart(2, "0");
  }, [selectedMonths]);

  const comparisonDayLimit = useMemo(() => {
    const fyEnd = parseInt(selectedYear, 10);
    if (!Number.isFinite(fyEnd)) return 31;
    return getMonthDayLimit(fyEnd, lastSelectedMonthValue);
  }, [selectedYear, lastSelectedMonthValue]);

  const comparisonTerritories = selectedValuesCsv(selectedTerritories);
  const comparisonCategories = selectedValuesCsv(selectedCategory, item => item.label);
  const comparisonBrands = selectedValuesCsv(selectedBrand);
  const comparisonMonths = selectedValuesCsv(selectedMonths);

  useEffect(() => {
    const sub = data.userProfile?.sub;
    if (!sub || !selectedYear) return;

    const controller = new AbortController();
    let cancelled = false;
    const timeout = setTimeout(async () => {
      try {
        setPriorYearComparisonLoading(true);
        const comparison = await fetchDashboardComparison({
          yearEnd: selectedYear,
          sub,
          signal: controller.signal,
          query: {
            territories: comparisonTerritories,
            categories: comparisonCategories,
            brands: comparisonBrands,
            months: comparisonMonths,
            endMonth: lastSelectedMonthValue,
            quarterEndMonth: quarterEndMonthValue,
            dayLimit: comparisonDayLimit,
          },
        });
        if (!cancelled) {
          setPriorYearComparison(comparison);
        }
      } catch (err) {
        if (!cancelled && err.name !== "AbortError") {
          console.error("Dashboard comparison fetch error:", err);
          setPriorYearComparison({ comparisons: {} });
        }
      } finally {
        if (!cancelled) {
          setPriorYearComparisonLoading(false);
        }
      }
    }, 350);

    return () => {
      cancelled = true;
      clearTimeout(timeout);
      controller.abort();
    };
  }, [
    data.userProfile?.sub,
    selectedYear,
    comparisonTerritories,
    comparisonCategories,
    comparisonBrands,
    comparisonMonths,
    lastSelectedMonthValue,
    quarterEndMonthValue,
    comparisonDayLimit,
  ]);

  const priorComparisons = priorYearComparison.comparisons || {};
  const priorRevenueOverMonth = priorComparisons.revenueOverMonth?.prior || [];
  const priorRevenueOverQuarter = priorComparisons.revenueOverQuarter?.prior || [];
  const priorRevenueByYear = priorComparisons.revenueByYear?.prior || [];
  const priorSalesByCases = priorComparisons.salesByCases?.prior || [];

const revenueOverMonthData = useMemo(() => {
  // FY end / start years
  const fyEndYear   = parseInt(selectedYear, 10);
  const fyStartYear = fyEndYear - 1;

  // The chosen month (01–12)
  const monthNum = parseInt(lastSelectedMonthValue, 10);

  // Determine the actual calendar year for this FY month
  // Apr–Dec belong to fyStartYear; Jan–Mar to fyEndYear
  const dataYear = monthNum >= 4 ? fyStartYear : fyEndYear;

  const today       = new Date();
  const isCurrent   = dataYear === today.getFullYear() && monthNum === (today.getMonth() + 1);
  const currentDay  = today.getDate();

  // How many days in that calendar month?
  const daysInMonth = isCurrent
    ? currentDay
    : new Date(dataYear, monthNum, 0).getDate();

  const labels = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const data   = Array(daysInMonth).fill(0);

  // Filter to only items in that exact calendar year & month
  const monthData = chartDailySeries.filter(d =>
    d.date.startsWith(`${dataYear.toString().padStart(4,'0')}-${lastSelectedMonthValue}`)
  );

  monthData.forEach(day => {
    const dayOfMonth = parseInt(day.date.slice(8, 10), 10);
    if (dayOfMonth >= 1 && dayOfMonth <= daysInMonth) {
      data[dayOfMonth - 1] += day.revenue;
    }
  });

  const total = data.reduce((sum, val) => sum + val, 0);

  return {
    total,
    labels,
    datasets: [
      {
        data,
        // styling stays the same
        backgroundColor: "#7b93AD",
        borderColor:     "#7b93AD",

      },
    ],
  };
}, [chartDailySeries, selectedYear, lastSelectedMonthValue]);

const revenueOverMonthChartData = useMemo(
  () => withPriorYearDataset(revenueOverMonthData, priorRevenueOverMonth),
  [revenueOverMonthData, priorRevenueOverMonth]
);

const revenueOverMonthOptions = useMemo(
  () => withoutChartLegend(chartExample1.options),
  []
);

const revenueOverQuarterData = useMemo(() => {
  // FY end / start years
  const fyEndYear   = parseInt(selectedYear, 10);
  const fyStartYear = fyEndYear - 1;

  // pick the last month (either filtered or today)
  const monthValues = selectedMonths.map(m => parseInt(m.value, 10));
  const lastSelectedMonth = monthValues.length > 0
    ? Math.max(...monthValues)
    : new Date().getMonth() + 1;

  // helper: for a given month (1–12), return a Date in the correct calendar year
  const getMonthDate = month => {
    const year = month >= 4 ? fyStartYear : fyEndYear;
    return new Date(Date.UTC(year, month - 1, 1));
  };

  // start from that “end” month
  const endMonthDate = getMonthDate(lastSelectedMonth);
  const labels = [];
  const data = [];

  for (let offset = 2; offset >= 0; offset--) {
    // subtract offset months
    const mDate = new Date(endMonthDate);
    mDate.setUTCMonth(endMonthDate.getUTCMonth() - offset);

    const mValue = String(mDate.getUTCMonth() + 1).padStart(2, "0");
    const mYear  = String(mDate.getUTCFullYear());
    labels.push(monthNumberToName[mValue] || mValue);

    const monthlyRevenue = chartDailySeries
      .filter(d =>
        d.date.substring(0, 4) === mYear &&
        d.date.substring(5, 7) === mValue
      )
      .reduce((sum, d) => sum + d.revenue, 0);

    data.push(monthlyRevenue);
  }

  const total = data.reduce((sum, val) => sum + val, 0);

  return {
    total,
    labels,
    datasets: [
      {
        ...(chartExample2?.data?.datasets?.[0] || {}),
        data,
        // styling stays the same
        backgroundColor: "#7b93AD",
        borderColor:     "#7b93AD",
      },
    ],
  };
}, [chartDailySeries, selectedMonths, selectedYear, monthNumberToName]);

const revenueOverQuarterChartData = useMemo(
  () => withPriorYearDataset(revenueOverQuarterData, priorRevenueOverQuarter),
  [revenueOverQuarterData, priorRevenueOverQuarter]
);

// Compute dynamic step size and axis max for the 3-month revenue chart
const quarterDataArray = [
  ...(revenueOverQuarterData?.datasets?.[0]?.data || []),
  ...priorRevenueOverQuarter,
]
  .map(Number)
  .filter(v => Number.isFinite(v));
const quarterMax = Math.max(0, ...quarterDataArray);
const computeNiceStep = (max) => {
  if (!max || max <= 0) return 1000; // sensible default
  const desiredTicks = 8; // aim for ~6–10 ticks
  const raw = max / desiredTicks;
  const pow10 = Math.pow(10, Math.floor(Math.log10(raw)));
  const norm = raw / pow10; // 1..10
  let nice;
  if (norm <= 1) nice = 1;
  else if (norm <= 2) nice = 2;
  else if (norm <= 5) nice = 5;
  else nice = 10;
  return nice * pow10;
};
const quarterStepSize = computeNiceStep(quarterMax);
const quarterYMax = quarterStepSize > 0
  ? Math.ceil(quarterMax / quarterStepSize) * quarterStepSize
  : quarterMax;

// Custom options for Revenue Over 3 Months chart with dynamic intervals
const revenueOverQuarterOptions = withoutChartLegend({
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
  scales: {
    y: {
      beginAtZero: true,
      max: quarterYMax,
      ticks: {
        color: "#1d1b1c",
        stepSize: quarterStepSize,
        maxTicksLimit: 20,
        callback: function(value) {
          return value.toLocaleString();
        }
      },
      grid: { drawBorder: false, display: false },
    },
    x: {
      grid: { drawBorder: false, display: false },
      ticks: { padding: 20, color: "#1d1b1c" },
    },
  },
});

  const revenueByYearData = useMemo(() => {
  // FY runs Apr (prev year) → Mar (selectedYear)
  const fyEndYear   = parseInt(selectedYear, 10);
  const fyStartYear = fyEndYear - 1;

  // labels: Apr, May, …, Dec, Jan, Feb, Mar
  const labels = [
    ...months.slice(3).map(m => m.label.substring(0, 3)),  // Apr–Dec
    ...months.slice(0, 3).map(m => m.label.substring(0, 3)) // Jan–Mar
  ];

  const data = Array(12).fill(0);

  chartDailySeries.forEach(day => {
    const year  = parseInt(day.date.substring(0, 4), 10);
    const month = parseInt(day.date.substring(5, 7), 10);

    let idx = -1;
    if (year === fyStartYear && month >= 4) {
      // Apr(4)→idx0, May(5)→idx1, … Dec(12)→idx8
      idx = month - 4;
    } else if (year === fyEndYear && month <= 3) {
      // Jan(1)→idx9, Feb(2)→idx10, Mar(3)→idx11
      idx = month + 8;
    }

    if (idx >= 0 && idx < 12) {
      data[idx] += day.revenue;
    }
  });

  const total = data.reduce((sum, val) => sum + val, 0);

  return {
    total,
    labels,
    datasets: [
      {
        label: 'Revenue',
        data,
        backgroundColor: '#7b93AD',
        borderColor:     '#7b93AD',
        borderWidth:     1,
      },
    ],
  };
}, [chartDailySeries, selectedYear]);

const revenueByYearChartData = useMemo(
  () => withPriorYearDataset(revenueByYearData, priorRevenueByYear),
  [revenueByYearData, priorRevenueByYear]
);

const revenueByYearOptions = useMemo(
  () => withoutChartLegend(chartExample3.options),
  []
);

const salesByCasesData = useMemo(() => {
  // Interpret selectedYear as the FY end (Apr→Mar)
  const fyEndYear   = parseInt(selectedYear, 10);
  const fyStartYear = fyEndYear - 1;

  const yearInfo = dashboardData[selectedYear] || {};
  // Prefer normalized daily from backend; else fallback to legacy territories.dailyData
  let normalizedDaily = [];
  if (Array.isArray(yearInfo.daily) && yearInfo.daily.length > 0) {
    normalizedDaily = yearInfo.daily.map(d => ({
      territory: Number(d.territory),
      date: d.date,
      totalCases: Number(d.totalCases || 0)
    }));
  } else if (Array.isArray(yearInfo.territories)) {
    normalizedDaily = yearInfo.territories.flatMap(t =>
      (t.dailyData || []).map(dd => ({
        territory: Number(t.territory),
        date: dd.date,
        totalCases: Number(dd.totalCases || 0)
      }))
    );
  }

  // Month labels in FY order
  const labels = [
    ...months.slice(3).map(m => m.label.substring(0, 3)),
    ...months.slice(0, 3).map(m => m.label.substring(0, 3))
  ];

  const pickedTerritoryIds = (selectedTerritories || []).map(t => Number(t.value));
  const monthFilter = (selectedMonths || []).map(m => m.value); // "01".."12"
  const hasCatFilter = selectedCategory && selectedCategory.length > 0;
  const hasBrandFilter = selectedBrand && selectedBrand.length > 0;

  const data = Array(12).fill(0);

  // If category/brand filters are active, use chartDailySeries (already filtered with cases)
  if (hasCatFilter || hasBrandFilter) {
    (chartDailySeries || []).forEach(d => {
      // territory filter can't be re-applied here (chartDailySeries is already filtered by territory if selected)
      const y = parseInt(d.date.substring(0, 4), 10);
      const m = parseInt(d.date.substring(5, 7), 10);
      if (monthFilter.length > 0 && !monthFilter.includes(String(m).padStart(2, '0'))) return;
      let idx = -1;
      if (y === fyStartYear && m >= 4) idx = m - 4;
      else if (y === fyEndYear && m <= 3) idx = m + 8;
      if (idx >= 0 && idx < 12) data[idx] += Number(d.cases || 0);
    });
  } else {
    // Otherwise use normalized/fallback daily totals (respect territory + month)
    normalizedDaily.forEach(d => {
    // Territory filter (if any)
    if (pickedTerritoryIds.length > 0 && !pickedTerritoryIds.includes(Number(d.territory))) {
      return;
    }

    const y = parseInt(d.date.substring(0, 4), 10);
    const m = parseInt(d.date.substring(5, 7), 10); // 1..12

    // Month filter (calendar months) if provided
    if (monthFilter.length > 0 && !monthFilter.includes(String(m).padStart(2, '0'))) {
      return;
    }

    let idx = -1;
    if (y === fyStartYear && m >= 4) {
      idx = m - 4;              // Apr(4)→0 .. Dec(12)→8
    } else if (y === fyEndYear && m <= 3) {
      idx = m + 8;              // Jan(1)→9 .. Mar(3)→11
    }

    if (idx >= 0 && idx < 12) {
      data[idx] += Number(d.totalCases || 0);
    }
    });
  }

  return {
    labels,
    datasets: [
      {
        ...(chartExample4?.data?.datasets?.[0] || {}),
        data,
      },
    ],
  };
}, [dashboardData, selectedYear, selectedTerritories, selectedMonths, chartDailySeries, selectedCategory, selectedBrand]);

const salesByCasesChartData = useMemo(
  () => withPriorYearDataset(salesByCasesData, priorSalesByCases),
  [salesByCasesData, priorSalesByCases]
);

const salesByCasesTotal = useMemo(
  () => (salesByCasesData?.datasets?.[0]?.data || [])
    .reduce((sum, value) => sum + Number(value || 0), 0),
  [salesByCasesData]
);

// --- Dynamic Y-axis for Sales by Cases ---
const casesDataArray = [
  ...(salesByCasesData?.datasets?.[0]?.data || []),
  ...priorSalesByCases,
]
  .map(Number)
  .filter(v => Number.isFinite(v));

// Use only months with data to compute dynamic bounds
const nonZeroCases = casesDataArray.filter(v => v > 0);
const casesMax = nonZeroCases.length ? Math.max(...nonZeroCases) : Math.max(0, ...casesDataArray);
const casesMin = nonZeroCases.length ? Math.min(...nonZeroCases) : 0;

// 10% padding above max and below min (clip at 0)
const rawRange = Math.max(1, casesMax - casesMin); // avoid 0
const pad = rawRange * 0.10;

let yMinRaw = Math.max(0, casesMin - pad);
let yMaxRaw = casesMax + pad;

// Compute nice step and snap min/max to nice values
const casesStep = computeNiceStep(yMaxRaw - yMinRaw);
let casesYMin = Math.floor(yMinRaw / casesStep) * casesStep;
let casesYMax = Math.ceil(yMaxRaw / casesStep) * casesStep;

// Safety fallback when data is empty or min==max
if (!Number.isFinite(casesYMin) || !Number.isFinite(casesYMax) || casesYMin >= casesYMax) {
  const fallbackMax = Math.max(100, casesMax || 1000);
  const fbStep = computeNiceStep(fallbackMax);
  casesYMin = 0;
  casesYMax = Math.ceil(fallbackMax / fbStep) * fbStep;
}

const salesByCasesOptions = withoutChartLegend({
  ...(chartExample4?.options || {}),
  plugins: {
    ...(chartExample4?.options?.plugins || {}),
    legend: { display: false },
    tooltip: { enabled: true }
  },
  scales: {
    ...(chartExample4?.options?.scales || {}),
    y: {
      ...(chartExample4?.options?.scales?.y || {}),
      beginAtZero: false,
      min: casesYMin,
      max: casesYMax,
      ticks: {
        ...(chartExample4?.options?.scales?.y?.ticks || {}),
        stepSize: casesStep,
        callback: (value) => formatCaseQuantity(value)
      },
      grid: { ...(chartExample4?.options?.scales?.y?.grid || {}), drawBorder: false }
    },
    x: {
      ...(chartExample4?.options?.scales?.x || {}),
      grid: { ...(chartExample4?.options?.scales?.x?.grid || {}), drawBorder: false, display: false },
      ticks: { ...(chartExample4?.options?.scales?.x?.ticks || {}), padding: 20 }
    }
  }
});



  const categoryChartData = useMemo(() => {
    const chartTemplates = {
      'Wine': chartWine,
      'RTD': chartRTD,
      'Cocktails': chartCocktails,
      'Cider': chartCider,
      'Mead': chartMead,
      'Spirits': chartSpirits,
      'Bitters': chartBitters,
      'Non-Alc': chartNonAlc
    };

    const generateDoughnutData = (targetCategoryName) => {
      const chartTemplate = chartTemplates[targetCategoryName];
      const originalOptions = chartTemplate?.options || {};
      const originalDataset = chartTemplate?.data?.datasets?.[0] || {};

      const createOptions = (total) => ({
        ...originalOptions,
        plugins: {
          ...originalOptions.plugins,
          tooltip: {
            callbacks: {
              label: (context) => {
                let label = context.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.raw) {
                    label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(context.raw);
                }
                return label;
              }
            }
          },
          title: {
            ...(originalOptions.plugins?.title || {}),
            display: true,
            text: `$${total.toLocaleString()}`
          }
        }
      });

      const emptyChart = (total = 0) => ({
        data: { labels: [], datasets: [{ ...originalDataset, data: [] }] },
        options: createOptions(total)
      });

      const selectedCategoryLabels = (selectedCategory || []).map(c => c.label);
      if (selectedCategoryLabels.length > 0 && !selectedCategoryLabels.includes(targetCategoryName)) {
        return emptyChart();
      }

      if (!filteredRawDailyData) {
        return emptyChart();
      }

      const selectedMonthValues = (selectedMonths || []).map(m => m.value);
      const monthFilteredDailyData = selectedMonthValues.length > 0
        ? filteredRawDailyData.filter(d => selectedMonthValues.includes(d.date.substring(5, 7)))
        : filteredRawDailyData;

      const brandRevenue = {};
      monthFilteredDailyData.forEach(day => {
        // Normalize and locate the matching category key for this target
        const dayCatKeyMap = {};
        Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
        const targetCatKey = dayCatKeyMap[normCat(targetCategoryName)];
        const categoryData = targetCatKey ? day.categories?.[targetCatKey] : undefined;
        if (categoryData && categoryData.brands) {
          for (const brandName in categoryData.brands) {
            if (!brandRevenue[brandName]) {
              brandRevenue[brandName] = 0;
            }
            brandRevenue[brandName] += (categoryData.brands[brandName].revenue || 0) / 100;
          }
        }
      });

      const selectedBrandNorms = (selectedBrand || [])
        .map(b => brandIdToName[b.value])
        .filter(Boolean)
        .map(norm);
      let finalBrandRevenue = brandRevenue;
      if (selectedBrandNorms.length > 0) {
        finalBrandRevenue = {};
        const revenueEntries = Object.entries(brandRevenue);
        const selSet = new Set(selectedBrandNorms);
        for (const [brandName, value] of revenueEntries) {
          if (selSet.has(norm(brandName))) {
            finalBrandRevenue[brandName] = value;
          }
        }
      }

      const labels = Object.keys(finalBrandRevenue);
      const dataValues = Object.values(finalBrandRevenue);
      const total = Math.round(dataValues.reduce((sum, val) => sum + val, 0));

      // Generate consistent colors for brands using the brand color mapping
      const backgroundColor = labels.map(brandName => getBrandColor(brandName, labels));

      const data = {
        labels: labels,
        datasets: [{
          ...originalDataset,
          data: dataValues,
          backgroundColor: backgroundColor,
        }]
      };

      return { data, options: createOptions(total) };
    };

    const allChartData = {};
    categories.forEach(category => {
      allChartData[category.name] = generateDoughnutData(category.name);
    });
    return allChartData;
  }, [filteredRawDailyData, selectedMonths, selectedCategory, selectedBrand, brandIdToName]);

   // --- Task Management State ---
  const [tasks, setTasks] = useState(initialTasksData);
  const [showCompleted, setShowCompleted] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [editingTask, setEditingTask] = useState(null); // null for new, task object for edit
  const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false); // Added for delete confirmation modal
  const [taskToDelete, setTaskToDelete] = useState(null); // Added to store ID of task to delete
  const [taskForm, setTaskForm] = useState({
    title: '',
    description: '',
    dueDate: '', // Store as YYYY-MM-DD for date input
    priority: 'medium',
    status: 'pending',
    userId: userProfile.id || '' // Default to current user if available
  });

  // --- Task Helper Functions ---
  const formatDate = (dateString) => {
    // console.log("Formatting date:", dateString);
    if (!dateString) return 'N/A';
    // Check if dateString is already just YYYY-MM-DD (from date input)
    if (dateString.length === 10 && dateString.includes('-')) {
        const [year, month, day] = dateString.split('-');
        // Create a date object at UTC to avoid timezone issues with toLocaleDateString
        return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
    }
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const getPriorityBadge = (priority) => {
    switch (priority) {
      case 'high': return <Badge color="danger" className="mr-1" pill>High</Badge>;
      case 'medium': return <Badge color="warning" className="mr-1" pill>Medium</Badge>;
      case 'low': return <Badge color="success" className="mr-1" pill>Low</Badge>;
      default: return <Badge color="secondary" className="mr-1" pill>{priority}</Badge>;
    }
  };
  
  const handleToggleComplete = (taskId) => {
    (async () => {
      try {
        const task = tasks.find(t => t.id === taskId);
        const newStatus = task.status === 'completed' ? 'pending' : 'completed';
        const updated = await updateTask(taskId, {
          status: newStatus,
          completedAt: newStatus === 'completed' ? new Date().toISOString() : null
        });
        setTasks(ts => ts.map(t => t.id === taskId ? updated : t));
      } catch (err) {
        console.error("Could not toggle complete:", err);
      }
    })();
  };

  const handleDeleteTask = (taskId) => {
    setTaskToDelete(taskId); // Set the task to be deleted
    setIsDeleteConfirmModalOpen(true); // Open the confirmation modal
  };

  const confirmDeleteTask = async () => {
    if (!taskToDelete) return;
    try {
      await deleteTask(taskToDelete);
      setTasks(ts => ts.filter(t => t.id !== taskToDelete));
    } catch (err) {
      console.error("Could not delete task:", err);
      // Optionally, show an error message to the user
    }
    setIsDeleteConfirmModalOpen(false); // Close the modal
    setTaskToDelete(null); // Reset the task to delete
  };

  const closeDeleteConfirmModal = () => {
    setIsDeleteConfirmModalOpen(false);
    setTaskToDelete(null);
  };

  const toggleTaskModal = (taskToEdit = null) => {
    if (taskToEdit) {
      setEditingTask(taskToEdit);
      setTaskForm({
        id: taskToEdit.id,
        title: taskToEdit.title,
        description: taskToEdit.description,
        dueDate: taskToEdit.dueDate ? taskToEdit.dueDate.split('T')[0] : '', // Format for <input type="date">
        priority: taskToEdit.priority,
        status: taskToEdit.status,
        userId: taskToEdit.userId
      });
    } else {
      setEditingTask(null);
      setTaskForm({ // Reset for new task
        title: '',
        description: '',
        dueDate: '',
        priority: 'medium',
        status: 'pending',
        userId: userProfile.id || '' // Default to current logged-in user
      });
    }
    setIsTaskModalOpen(!isTaskModalOpen);
  };

  const handleTaskFormChange = (e) => {
    const { name, value } = e.target;
    setTaskForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveTask = () => {
    (async () => {
      try {
        let result;
        const payload = {
          userId:     taskForm.userId,
          title:      taskForm.title,
          description:taskForm.description,
          status:     taskForm.status,
          priority:   taskForm.priority,
          dueDate:    taskForm.dueDate ? `${taskForm.dueDate}T00:00:00.000Z` : null
        };

        if (editingTask && editingTask.id) {
          result = await updateTask(editingTask.id, payload);
          setTasks(ts => ts.map(t => t.id === result.id ? result : t));
        } else {
          result = await createTask(payload);
          setTasks(ts => [...ts, result]);
        }

        toggleTaskModal();
      } catch (err) {
        console.error("Could not save task:", err);
      }
    })();
  };

  const filteredTasks = useMemo(() => {
    return tasks
      .filter(task => showCompleted ? task.status === 'completed' : task.status !== 'completed')
      .sort((a, b) => {
        const dateA = a.dueDate ? new Date(a.dueDate) : null;
        const dateB = b.dueDate ? new Date(b.dueDate) : null;
        if (dateA && dateB) return dateA - dateB;
        if (dateA && !dateB) return -1; // Tasks with due dates come first
        if (!dateA && dateB) return 1;
        // If both have no due dates, or both have same due date, sort by creation (optional)
        return new Date(b.created_at) - new Date(a.created_at); // Newest first among those
      });
  }, [tasks, showCompleted]);


  const handleCustomerRowClick = (customer) => {
    // Find the full customer object from the main customers list in DataContext
    const fullCustomer = data.customers?.find(c => c.businessName === customer.name || c.id === customer.id);
    if (fullCustomer) {
      navigate("/admin/customer", { state: { selectedCustomerId: fullCustomer.id } });
    } else {
      const customerFromMarkers = data.customers?.find(c => c.id === customer.id);
      if (customerFromMarkers) {
        navigate("/admin/customer", { state: { selectedCustomerId: customerFromMarkers.id } });
      } else {
        console.warn("Customer not found in DataContext, cannot navigate to details:", customer);
      }
    }
  };

  useEffect(() => {
    // if (isSales) {
    //   const meOption = { value: userProfile.id, label: userProfile.name };
    //   setSelectedRep([meOption]);
    // }

    const handleResize = () => {
      setShowHashColumn(window.innerWidth >= 1050);
      setShowTerritoryColumn(window.innerWidth >= 400);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); 

    return () => window.removeEventListener('resize', handleResize);
  }, [isSales, userProfile.id, userProfile.name]); 


// 1) Monthly by date, newest first
const monthlyDateStats = useMemo(() => {
  const month = lastSelectedMonthValue;
  const days = filteredDailyData.filter(d => d.date?.substring(5,7) === month);

  const totalMonthRevenue = days.reduce((sum, d) => sum + d.revenue, 0);

  return days
    .map(d => ({
      date:       d.date,
      sales:      d.revenue,
      percent:    totalMonthRevenue ? (d.revenue / totalMonthRevenue) * 100 : 0,
      orderCount: d.orders,
    }))
    // drop any rows without a valid date
    .filter(r => r.date)
    // newest → oldest
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}, [filteredDailyData, lastSelectedMonthValue]);

// 2) Monthly by territory, A→Z, but only the ones you've picked
const monthlyTerritoryStats = useMemo(() => {
  const yearInfo           = dashboardData[selectedYear] || {};
  const allTerritories     = data.territories || [];
  const month              = lastSelectedMonthValue;
  const pickedTerritoryIds = selectedTerritories.map(t => t.value);

  // Check if category/brand filters are applied
  const hasCategoryFilter = selectedCategory && selectedCategory.length > 0;
  const hasBrandFilter = selectedBrand && selectedBrand.length > 0;
  const hasBoth = hasCategoryFilter && hasBrandFilter;

  if (!hasCategoryFilter && !hasBrandFilter) {
    // Prefer normalized daily feed to stay consistent with Revenue Achieved totals.
    const normalizedRows = normalizedTerritoryDaily
      .filter(row => row.territory != null)
      .filter(row => row.date?.slice(5,7) === month);

    if (normalizedRows.length > 0) {
      const byTerritory = normalizedRows.reduce((acc, row) => {
        const key = String(row.territory);
        if (!acc[key]) {
          acc[key] = { territoryId: key, revenue: 0, orders: 0 };
        }
        acc[key].revenue += Number(row.totalRevenue ?? row.revenue ?? 0) || 0;
        acc[key].orders  += Number(row.totalOrders ?? row.orders ?? 0) || 0;
        return acc;
      }, {});

      const stats = Object.values(byTerritory).map(stat => {
        const territoryName =
          allTerritories.find(tt => String(tt.id) === stat.territoryId)?.name ||
          stat.territoryId;
        return {
          territory: territoryName,
          revenue: stat.revenue,
          orders: stat.orders,
        };
      });

      const totalRev = stats.reduce((sum, r) => sum + r.revenue, 0);
      const withPct  = stats.map(r => ({
        ...r,
        percent: totalRev ? (r.revenue / totalRev) * 100 : 0
      }));

      return withPct
        .filter(r => r.territory && r.territory.trim());
    }

    // Fallback to legacy territory buckets when normalized data is unavailable.
    const territoryBuckets = (yearInfo.territories || [])
      .filter(t => 
        pickedTerritoryIds.length === 0 ||
        pickedTerritoryIds.includes(t.territory)
      );

    const stats = territoryBuckets.map(t => {
      const days    = (t.dailyData || []).filter(d => d.date?.slice(5,7) === month);
      const revenue = days.reduce((sum, d) => sum + parseFloat(d.totalRevenue), 0);
      const orders  = days.reduce((sum, d) => sum + parseInt(d.totalOrders,10), 0);

      const name = allTerritories.find(tt => tt.id === t.territory)?.name || t.territory;
      return { territory: name, revenue, orders };
    });

    const totalRev = stats.reduce((sum, r) => sum + r.revenue, 0);
    const withPct  = stats.map(r => ({
      ...r,
      percent: totalRev ? (r.revenue / totalRev) * 100 : 0
    }));

    return withPct
      .filter(r => r.territory && r.territory.trim());
  }

  // When filters are applied, calculate territory stats directly from territory's daily data
  const selectedCategoryNorms = hasCategoryFilter ? selectedCategory.map(c => normCat(c.label)) : [];
  const selectedBrandNorms = hasBrandFilter ? selectedBrand.map(b => brandIdToName[b.value]).filter(Boolean).map(norm) : [];

  const territoryBuckets = (yearInfo.territories || [])
    .filter(t =>
      pickedTerritoryIds.length === 0 ||
      pickedTerritoryIds.includes(t.territory)
    );

  const stats = territoryBuckets.map(t => {
    const days = (t.dailyData || []).filter(d => d.date?.slice(5,7) === month);
    let revenue = 0;
    let orders = 0;

    days.forEach(day => {
      if (hasBoth) {
        const dayCatKeyMap = {};
        Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
        selectedCategoryNorms.forEach(catNorm => {
          const catKey = dayCatKeyMap[catNorm];
          const catData = catKey ? day.categories?.[catKey] : undefined;
          if (catData && catData.brands) {
            const catBrandKeyMap = {};
            Object.keys(catData.brands || {}).forEach(k => { catBrandKeyMap[norm(k)] = k; });
            selectedBrandNorms.forEach(brandNorm => {
              const bKey = catBrandKeyMap[brandNorm];
              const bd = bKey ? catData.brands[bKey] : undefined;
              if (bd) {
                revenue += (bd.revenue || 0) / 100;
                orders  += Number(bd.orders || 0);
              }
            });
          }
        });
      } else if (hasCategoryFilter) {
        const dayCatKeyMap = {};
        Object.keys(day.categories || {}).forEach(k => { dayCatKeyMap[normCat(k)] = k; });
        selectedCategoryNorms.forEach(catNorm => {
          const catKey = dayCatKeyMap[catNorm];
          const catData = catKey ? day.categories?.[catKey] : undefined;
          if (catData) {
            revenue += (catData.revenue || 0) / 100;
            orders  += Number(catData.orders || 0);
          }
        });
      } else if (hasBrandFilter) {
        const dayBrandKeyMap = {};
        Object.keys(day.brands || {}).forEach(k => { dayBrandKeyMap[norm(k)] = k; });
        selectedBrandNorms.forEach(brandNorm => {
          const bKey = dayBrandKeyMap[brandNorm];
          const brandData = bKey ? day.brands?.[bKey] : undefined;
          if (brandData) {
            revenue += (brandData.revenue || 0) / 100;
            orders  += Number(brandData.orders || 0);
          }
        });
      }
    });

    const name = allTerritories.find(tt => tt.id === t.territory)?.name || t.territory;
    return { territory: name, revenue, orders };
  });

  const totalRev = stats.reduce((sum, r) => sum + r.revenue, 0);
  const withPct = stats.map(r => ({
    ...r,
    percent: totalRev ? (r.revenue / totalRev) * 100 : 0
  }));

  return withPct
    .filter(r => r.territory && r.territory.trim());
}, [dashboardData, selectedYear, lastSelectedMonthValue, data.territories, selectedTerritories, selectedCategory, selectedBrand, brandIdToName, normalizedTerritoryDaily]);

const sortedMonthlyTerritoryStats = useMemo(() => {
  return [...monthlyTerritoryStats].sort((a, b) => {
    let aVal, bVal;
    
    switch (territorySortField) {
      case 'territory':
        aVal = a.territory.toLowerCase();
        bVal = b.territory.toLowerCase();
        return territorySortDirection === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      
      case 'revenue':
        aVal = a.revenue;
        bVal = b.revenue;
        return territorySortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'percent':
        aVal = a.percent;
        bVal = b.percent;
        return territorySortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'orders':
        aVal = a.orders;
        bVal = b.orders;
        return territorySortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      
      default:
        return 0;
    }
  });
}, [monthlyTerritoryStats, territorySortField, territorySortDirection]);

    
    return (
      <>
          {yearLoading && (
      <div
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(255,255,255,0.75)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}
      >
        <Spinner color="primary" size="lg" />
      </div>
    )}

        <div className="content">
          {/* ─── FILTER BAR ─────────────────────────────────────────────────────── */}
          <Row form className="mb-4">
          <Col md="1">

            <FormGroup>
              <Label for="yearFilter">Year</Label>
              <Input
                type="select"
                id="yearFilter"
                value={selectedYear}
                onChange={e => setSelectedYear(e.target.value)}
              >
                {yearOptions.map(y => (
                  <option key={y} value={y}>{formatFYLabel(y)}</option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label for="monthFilter">Month</Label>
                <CheckboxMultiSelect
                  id="monthFilter"
                  options={months}
                  value={selectedMonths}
                  onChange={setSelectedMonths}
                  placeholder="All Months"
                />
              </FormGroup>
            </Col>
          <Col md="3">
    <FormGroup>
      <Label for="categoryFilter">Category</Label>
      <CheckboxMultiSelect
        id="categoryFilter"
        options={categoryOptions}
        value={selectedCategory}
        onChange={setSelectedCategory}
        placeholder="All Categories"
      />
    </FormGroup>
  </Col>

  <Col md="3">
    <FormGroup>
      <Label for="brandFilter">Brand</Label>
      <CheckboxMultiSelect
        id="brandFilter"
        options={brandOptions}
        value={selectedBrand}
        onChange={setSelectedBrand}
        placeholder="All Brands"
      />
    </FormGroup>
  </Col>

  {/* <Col md="3">
    <FormGroup>
      <Label for="repFilter">Sales Rep</Label>
      <Select
        id="repFilter"
        isMulti
        options={salesReps.map(u => ({ value: u.id, label: u.name }))}
        value={selectedRep}
        isDisabled={isSales} 
        onChange={(value) => setSelectedRep(value || [])}
        placeholder="All Reps"
      />
    </FormGroup>
  </Col> */}
     
 <Col md="3">
   <FormGroup>
     <Label for="territoryFilter">Territory</Label>
     <CheckboxMultiSelect
       id="territoryFilter"
       options={territoryOptions}
       value={selectedTerritories}
       onChange={setSelectedTerritories}
       placeholder="All Territories"
     />
   </FormGroup>
 </Col>
          </Row>

          
          <Row>
            <Col lg="3" md="6" sm="6" className="d-flex">
              <Card className="card-stats flex-fill">
                <CardBody>
                  <Row>
                    <Col md="4" xs="5">
                      <div className="icon-big text-center icon-warning">
                        <i className="nc-icon nc-globe text-warning" />
                      </div>
                    </Col>
                    <Col md="8" xs="7">
                      <div className="numbers">
                        <p className="card-category">Target</p>
                        <CardTitle tag="p">{formatRevenue(targetRevenue)}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="fa fa-circle-o" />
                    Budgets set for the year
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="d-flex">
              <Card className="card-stats flex-fill">
                <CardBody>
                  <Row>
                    <Col md="4" xs="5">
                      <div className="icon-big text-center icon-warning">
                        <i className="nc-icon nc-money-coins text-success" />
                      </div>
                    </Col>
                    <Col md="8" xs="7">
                      <div className="numbers">
                        <p className="card-category">Achieved</p>
                        <CardTitle tag="p">{formatRevenue(totalFilteredRevenue)}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="fa fa-circle-o" />
                    Revenue Achieved
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="d-flex">
              <Card className="card-stats flex-fill">
                <CardBody>
                  <Row>
                    <Col md="4" xs="5">
                      <div className="icon-big text-center icon-warning">
                        <i className="nc-icon nc-vector text-danger" />
                      </div>
                    </Col>
                    <Col md="8" xs="7">
                      <div className="numbers">
                        <p className="card-category">% Achieved</p>
                        <CardTitle tag="p">{percentageAchieved.toFixed(0)}%</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="fa fa-circle-o" />
                    Percentage of target achieved
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6" className="d-flex">
              <Card className="card-stats flex-fill">
                <CardBody>
                  <Row>
                    <Col md="4" xs="5">
                      <div className="icon-big text-center icon-warning">
                        <i className="nc-icon nc-favourite-28 text-primary" />
                      </div>
                    </Col>
                    <Col md="8" xs="7">
                      <div className="numbers">
                        <p className="card-category">Total Orders</p>
                        <CardTitle tag="p">{totalFilteredOrders}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="fa fa-circle-o" />
                    Number of orders
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            
            <Col lg="4" sm="6" className="d-flex">
              <Card className="flex-fill d-flex flex-column">
                <CardHeader>
                  <Row>
                    <Col sm="7">
                      <div className="numbers pull-left">{formatRevenue(revenueOverQuarterData.total || 0)}</div>
                    </Col>
                    <Col sm="5">
                      {/* <div className="pull-right">
                        <Badge color="warning" pill>
                          -14%
                        </Badge>
                      </div> */}
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="flex-grow-1">
                  <h6 className="big-title">
                    Revenue Over 3 Months 
                  </h6>
                  <Bar
                    data={revenueOverQuarterChartData}
                    options={revenueOverQuarterOptions}
                    height={380}
                    width={828}
                  />
                </CardBody>
                <CardFooter>
                  <hr />
                  <Row>
                    <Col sm="12">
                      <div className="footer-title">
                        Revenue over latest three months
                        {priorYearComparisonLoading && (
                          <span className="ml-2">
                            <i className="fa fa-spinner fa-spin" />
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col sm="5">
                      <div className="pull-right">
                        {/* <Button
                          className="btn-round btn-icon"
                          color="warning"
                          size="sm"
                        >
                          <i className="nc-icon nc-button-play" />
                        </Button> */}
                      </div>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="4" sm="6" className="d-flex">
              <Card className="flex-fill d-flex flex-column">
                <CardHeader>
                  <Row>
                    <Col sm="7">
                      <div className="numbers pull-left">{formatRevenue(revenueByYearData.total || 0)}</div>
                    </Col>
                    <Col sm="5">
                      {/* <div className="pull-right">
                        <Badge color="info" pill>
                          ~51%
                        </Badge>
                      </div> */}
                    </Col>
                    
                  </Row>
                </CardHeader>
                <CardBody className="flex-grow-1">
                  <h6 className="big-title">Revenue by year</h6>
                  <Bar
                    data={revenueByYearChartData}
                    options={revenueByYearOptions}
                    height={380}
                    width={826}
                  />
                </CardBody>
                <CardFooter>
                  <hr />
                  <Row>
                    <Col sm="12">
                      <div className="footer-title">Yearly revenue split by month</div>
                    </Col>
                    <Col sm="5">
                      <div className="pull-right">
                        {/* <Button
                          className="btn-round btn-icon"
                          color="info"
                          size="sm"
                        >
                          <i className="nc-icon nc-alert-circle-i" />
                        </Button> */}
                      </div>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="4" sm="6" className="d-flex">
              <Card className="flex-fill d-flex flex-column">
              <CardHeader>
                <CardTitle tag="h4">Sales by Cases</CardTitle>
              </CardHeader>
              <CardBody>
                <Bar
                  data={salesByCasesChartData}
                  options={salesByCasesOptions}
                />
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  {/* <i className="fa fa-check" /> */}
                  Number of cases sold by month. Total: {formatCaseQuantity(salesByCasesTotal)}
                </div>
              </CardFooter>
            </Card>
            </Col>
          </Row>
          <Row>
            <Col md="6" className="d-flex"> 
              <Card className="flex-fill d-flex flex-column"> 
                <CardHeader>
                  <CardTitle tag="h4">Top Customers</CardTitle>
                </CardHeader>
                <CardBody style={{ padding: 0, flex: '1 1 auto', overflowY: 'hidden' }}> 
                  <div style={{ overflowY: 'auto', height: '100%' }}> 
                    <Table className="table-hover mb-0">
                      <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                        <tr>
                          {showHashColumn && <th>#</th>}
                          <th>Name</th>
                          {showTerritoryColumn && <th>Territory</th>}
                          <th className="text-right">Orders</th>
                          <th className="text-right">Revenue ($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingTopCustomers ? (
                          <tr>
                            <td colSpan={ (showHashColumn?1:0) + 1 + (showTerritoryColumn?1:0) + 2 } className="text-center">
                              <i className="fa fa-spinner fa-spin" /> Loading customers...
                            </td>
                          </tr>
                        ) : displayedTopCustomers.length > 0
                          ? displayedTopCustomers
                              .slice(0, 10)                 // <- top 10 customers
                              .map((cust, idx) => {
                              // look up the territory name
                              const terr = data.territories.find(t => t.id === cust.territory);
                              return (
                                <tr
                                  key={cust.customerId}
                                  onClick={() => handleCustomerRowClick(cust)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {showHashColumn && <td>{idx + 1}</td>}
                                  <td>{cust.name}</td>
                                  {showTerritoryColumn && <td>{terr ? terr.name : cust.territory}</td>}
                                  <td className="text-right">{cust.totalOrders}</td>
                                  <td className="text-right">
                                    {Number(cust.totalRevenue).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </td>
                                </tr>
                              );
                            })
                          : (
                              <tr>
                                <td colSpan={ (showHashColumn?1:0) + 1 + (showTerritoryColumn?1:0) + 2 } className="text-center">
                                  No top customers
                                </td>
                              </tr>
                            )
                        }
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="6" className="d-flex">
            <Card className="flex-fill d-flex flex-column">
                <CardHeader>
                  <Row>
                    <Col sm="7">
                      <div className="numbers pull-left">{formatRevenue(revenueOverMonthData.total || 0)}</div>
                    </Col>
                    <Col sm="5">
                      {/* <div className="pull-right">
                        <Badge color="success" pill>
                          +18%
                        </Badge>
                      </div> */}
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="flex-grow-1">
                  <h6 className="big-title">
                    Revenue over {monthNumberToName[lastSelectedMonthValue]}
                  </h6>
                  <Bar
                    data={revenueOverMonthChartData}
                    options={revenueOverMonthOptions}
                    height={380}
                    width={826}
                  />
                </CardBody>
                <CardFooter>
                  <hr />
                  <Row>
                    <Col sm="12">
                    
                      <div className="footer-title">Revenue for a single month </div>
                    </Col>
                    <Col sm="5">
                      <div className="pull-right">
                        {/* <Button
                          className="btn-round btn-icon"
                          color="success"
                          size="sm"
                        >
                          <i className="nc-icon nc-simple-add" />
                        </Button> */}
                      </div>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
          
          </Col>
          </Row>

          {/* --- TASKS SECTION --- */}
           <Row>
            <Col md="12" className="d-flex">
              <Card className="flex-fill d-flex flex-column">
                <CardHeader>
                  <Row className="align-items-center justify-content-between">
                    <Col xs="auto" className="mr-auto"> {/* Pushes title to the left */}
                      <CardTitle tag="h4" className="mb-0">Tasks</CardTitle>
                    </Col>
                    <Col xs="auto"> {/* Container for buttons on the right */}
                      <Button color="info" size="sm" onClick={() => setShowCompleted(!showCompleted)}>
                        {showCompleted ? 
                          <><i className="nc-icon nc-check-2 mr-1" /> Hide</> : 
                          <><i className="nc-icon nc-bullet-list-67 mr-1" /> Show</>
                        }
                         <span className="d-none d-sm-inline ml-1">Completed</span>
                      </Button>
                      <Button color="primary" size="sm" onClick={() => toggleTaskModal()} className="mr-1">
                        <i className="nc-icon nc-simple-add" />
                        <span className="d-none d-sm-inline ml-1">New</span>
                      </Button>

                    </Col>
                  </Row>
                </CardHeader>
                <CardBody style={{ flex: '1 1 auto', overflowY: 'auto', padding: '0.5rem' }}>
                  {filteredTasks.length === 0 ? (
                     <div className="text-center text-muted p-5">
                        No {showCompleted ? 'completed' : 'pending/in-progress'} tasks.
                     </div>
                  ) : (
                    <ListGroup flush>
                    {filteredTasks.map(task => {
                      const assignee = (data.users || []).find(u => u.id === task.userId);
                      let initials = ''
                      let assigneeName = 'Unknown User';
                      let avatarColor = '#cccccc'; // Default color for blank or unknown user

                      if (assignee && assignee.name) {
                        assigneeName = assignee.name;
                        initials = getInitials(assigneeName);
                        
                        const colors = ['#007bff', '#6610f2', '#6f42c1', '#e83e8c', '#dc3545', '#fd7e14', '#ffc107', '#28a745', '#20c997', '#17a2b8'];
                        let colorIndex = 0;
                        if (assignee.id && typeof assignee.id === 'string') {
                            for (let i = 0; i < assignee.id.length; i++) {
                                colorIndex = (colorIndex + assignee.id.charCodeAt(i)) % colors.length;
                            }
                            avatarColor = colors[colorIndex];
                        } else if (assignee.id && typeof assignee.id === 'number') { 
                            colorIndex = assignee.id % colors.length;
                            avatarColor = colors[colorIndex];
                        } 
                      } else if (assignee) {
                        assigneeName = `User ID: ${assignee.id}`;
                      } 

                      const itemStyle = {};
                      if (task.dueDate && task.status !== 'completed') {
                        const dueDate = new Date(task.dueDate);
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Normalize today to the start of the day
                        dueDate.setHours(0,0,0,0); // Normalize due date to the start of the day for fair comparison

                        if (dueDate < today) {
                          itemStyle.backgroundColor = 'rgba(255, 0, 0, 0.2)'; // 20% red background
                        }
                      }

                      return (
                        <ListGroupItem key={task.id} className="px-2 py-3" style={itemStyle}>
                          <Row className="align-items-center">
                            <Col xs="auto" className="d-flex align-items-center pr-2">
                              {/* Initials Avatar */}
                              <div
                                title={assigneeName} // Show name or ID on hover
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: avatarColor,
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  fontWeight: 'bold',
                                  marginRight: '10px'
                                }}
                              >
                                {initials}
                              </div>
                            </Col>
                            {/* Removed the Col that contained the FormGroup check */}
                            <Col style={{ textDecoration: task.status === 'completed' ? 'line-through' : 'none' }}>
                              <h6 className={`mb-0 ${task.status === 'completed' ? 'text-muted' : ''}`}>
                                {task.title}
                              </h6>
                              {task.description && <small className="text-muted d-block mt-1">{task.description}</small>}
                              <div className="mt-1">
                                {getPriorityBadge(task.priority)}
                                <Badge color="light" className="text-dark mr-1" pill>
                                    <i className="nc-icon nc-calendar-60 mr-1"/>Due: {formatDate(task.dueDate)}
                                </Badge>
                                {task.status === 'completed' && task.completed_at && (
                                    <Badge color="light" className="text-success" pill>
                                        <i className="nc-icon nc-check-2 mr-1"/>Completed: {formatDate(task.completed_at)}
                                    </Badge>
                                )}
                              </div>
                            </Col>
                            <Col xs="auto" className="text-right">
                              <Button
                                className="btn-round btn-icon btn-icon-mini"
                                color="info"
                                id={`edit-task-${task.id}`}
                                onClick={() => toggleTaskModal(task)}
                              >
                                <i className="nc-icon nc-ruler-pencil" />
                              </Button>
                              <UncontrolledTooltip delay={0} target={`edit-task-${task.id}`}>Edit Task</UncontrolledTooltip>
                              
                              {/* Conditional rendering for the complete button and its tooltip */}
                              {task.status !== 'completed' && task.userId === userProfile.id && (
                                <>
                                  <Button
                                  className="btn-round btn-icon btn-icon-mini"
                                  color="success"
                                  id={`complete-task-${task.id}`}
                                  onClick={() => handleToggleComplete(task.id)}
                                  >
                                  <i className="nc-icon nc-check-2" />
                                  </Button>
                                  <UncontrolledTooltip delay={0} target={`complete-task-${task.id}`}>Mark as Complete</UncontrolledTooltip>
                                </> 
                              )}

                              <Button
                                className="btn-round btn-icon btn-icon-mini"
                                color="danger"
                                id={`delete-task-${task.id}`}
                                onClick={() => handleDeleteTask(task.id)}
                              >
                                <i className="nc-icon nc-simple-remove" />
                              </Button>
                              <UncontrolledTooltip delay={0} target={`delete-task-${task.id}`}>Delete Task</UncontrolledTooltip>
                            </Col>
                          </Row>
                        </ListGroupItem>
                      )
                    })}
                  </ListGroup>
                  )}
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="fa fa-history" /> {filteredTasks.length} {showCompleted ? 'completed' : 'active'} tasks
                  </div>
                </CardFooter>
              </Card>
            </Col>
        </Row> 
          <Row className="mb-4">
  {/* Monthly Sales by Date */}
  <Col md="6">
    <Card className="h-100">
      <CardHeader><CardTitle tag="h5">Monthly Sales By Date</CardTitle></CardHeader>
      <CardBody style={{ padding: 0, maxHeight: '300px', overflowY: 'auto' }}>
        <Table striped>
          <thead>
            <tr>
              <th>Date</th>
              <th className="text-right">Sales ($)</th>
              <th className="text-right">% of Month</th>
              <th className="text-right"># Orders</th>
            </tr>
          </thead>
          <tbody>
            {monthlyDateStats.map(row => (
              <tr key={row.date}>
                <td>{new Date(row.date).toLocaleDateString()}</td>
                <td className="text-right">${Math.round(row.sales)}</td>
                <td className="text-right">{row.percent.toFixed(1)}%</td>
                <td className="text-right">{row.orderCount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  </Col>

  {/* Monthly Sales by Territory */}
  <Col md="6">
    <Card className="h-100">
      <CardHeader><CardTitle tag="h5">Monthly Sales By Territory</CardTitle></CardHeader>
      <CardBody style={{ padding: 0, maxHeight: '300px', overflowY: 'auto' }}>
        <Table striped>
          <thead>
            <tr>
              <th 
                style={{ cursor: 'pointer' }}
                onClick={() => handleTerritorySort('territory')}
              >
                Territory {territorySortField === 'territory' && (territorySortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th 
                className="text-right"
                style={{ cursor: 'pointer' }}
                onClick={() => handleTerritorySort('revenue')}
              >
                Sales ($) {territorySortField === 'revenue' && (territorySortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th 
                className="text-right"
                style={{ cursor: 'pointer' }}
                onClick={() => handleTerritorySort('percent')}
              >
                % of Month {territorySortField === 'percent' && (territorySortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th 
                className="text-right"
                style={{ cursor: 'pointer' }}
                onClick={() => handleTerritorySort('orders')}
              >
                # Orders {territorySortField === 'orders' && (territorySortDirection === 'asc' ? '↑' : '↓')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedMonthlyTerritoryStats.map(r => (
              <tr key={r.territory}>
                <td>{r.territory}</td>
                <td className="text-right">${Math.round(r.revenue)}</td>
                <td className="text-right">{r.percent.toFixed(1)}%</td>
                <td className="text-right">{r.orders}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  </Col>
</Row>
      {/* ─── Category Doughnut Charts ───────────────────────────────────────────── */}
      <Row className="mb-3"> 
        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Wine</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Wine']?.data || chartWine.data}
                options={categoryChartData['Wine']?.options || chartWine.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>

        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>RTD</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['RTD']?.data || chartRTD.data}
                options={categoryChartData['RTD']?.options || chartRTD.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>

        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Cocktails</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Cocktails']?.data || chartCocktails.data}
                options={categoryChartData['Cocktails']?.options || chartCocktails.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>

        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Cider</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Cider']?.data || chartCider.data}
                options={categoryChartData['Cider']?.options || chartCider.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>
      </Row>

      <Row className="mb-4"> 
      <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Mead</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Mead']?.data || chartMead.data}
                options={categoryChartData['Mead']?.options || chartMead.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>
        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Spirits</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Spirits']?.data || chartSpirits.data}
                options={categoryChartData['Spirits']?.options || chartSpirits.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>

        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Bitters</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Bitters']?.data || chartBitters.data}
                options={categoryChartData['Bitters']?.options || chartBitters.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>

        <Col md="3">
          <Card className="h-100 d-flex flex-column">
            <CardHeader><CardTitle>Non-Alc</CardTitle></CardHeader>
            <CardBody style={{ height: "253px" }}>
              <Doughnut
                data={categoryChartData['Non-Alc']?.data || chartNonAlc.data}
                options={categoryChartData['Non-Alc']?.options || chartNonAlc.options}
              />
            </CardBody>
            {/* <CardFooter>
              <hr/>
              <div className="stats"><i className="fa fa-calendar"/> April 2025</div>
            </CardFooter> */}
          </Card>
        </Col>
      </Row>
   

          {/* --- RECENT ORDERS TABLE --- */}
          <Row>
            <Col md="12" className="d-flex">
              <Card className="flex-fill d-flex flex-column">
                <CardHeader>
                  <CardTitle tag="h4">Latest Orders</CardTitle>
                </CardHeader>
                <CardBody style={{ padding: 0, flex: '1 1 auto', overflowY: 'hidden' }}>
                  <div style={{ overflowY: 'auto', height: '100%', maxHeight: '300px' /* Adjust height as needed */ }}>
                    <Table className="table-hover mb-0">
                      <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                        <tr>
                          <th>Order ID</th>
                          <th>Customer</th>
                          <th>Date</th>
                          <th className="text-right">Total ($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentOrders.length > 0 ? recentOrders.map((order, index) => (
                          <tr key={order.orderId || index} onClick={() => handleDashboardOrderClick(order)} style={{ cursor: 'pointer' }}>
                            <td>{order.orderId}</td>
                            <td>{order.customerName}</td>
                            <td>{new Date(order.date).toLocaleDateString()}</td>
                            <td className="text-right">{Number(order.total).toFixed(2)}</td>
                          </tr>
                        )) : (
                          <tr><td colSpan="4" className="text-center">No recent orders found.</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>

      {/* Task Modal */}
      <Modal isOpen={isTaskModalOpen} toggle={() => toggleTaskModal()} centered size="lg">
        <ModalHeader toggle={() => toggleTaskModal()}>
          {editingTask ? 'Edit Task' : 'Add New Task'}
        </ModalHeader>
        <ModalBody>
          {(userProfile.role === 'admin' || userProfile.is_superuser) && (
            <FormGroup>
              <Label for="taskAssignee">Assign to</Label>
              <Input
                type="select"
                name="userId" // This should match the key in taskForm
                id="taskAssignee"
                value={taskForm.userId} // Controlled component
                onChange={handleTaskFormChange} // Updates taskForm.userId
              >
                {(data.users || []).map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          )}
          <FormGroup>
            <Label for="taskTitle">Title <span className="text-danger">*</span></Label>
            <Input
              type="text"
              name="title"
              id="taskTitle"
              value={taskForm.title}
              onChange={handleTaskFormChange}
              placeholder="Enter task title"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="taskDescription">Description</Label>
            <Input
              type="textarea"
              name="description"
              id="taskDescription"
              rows="3"
              value={taskForm.description}
              onChange={handleTaskFormChange}
              placeholder="Enter task description"
            />
          </FormGroup>
          <Row form>
              <Col md={6}>
                  <FormGroup>
                  <Label for="taskDueDate">Due Date</Label>
                  <Input
                      type="date"
                      name="dueDate"
                      id="taskDueDate"
                      value={taskForm.dueDate} // Expects YYYY-MM-DD
                      onChange={handleTaskFormChange}
                  />
                  </FormGroup>
              </Col>
              <Col md={6}>
                  <FormGroup>
                  <Label for="taskPriority">Priority</Label>
                  <Input
                      type="select"
                      name="priority"
                      id="taskPriority"
                      value={taskForm.priority}
                      onChange={handleTaskFormChange}
                  >
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                  </Input>
                  </FormGroup>
              </Col>
          </Row>
          {editingTask && (
              <FormGroup>
                  <Label for="taskStatus">Status</Label>
                  <Input
                  type="select"
                  name="status"
                  id="taskStatus"
                  value={taskForm.status}
                  onChange={handleTaskFormChange}
                  >
                  <option value="pending">Pending</option>
                  <option value="in-progress">In Progress</option>
                  <option value="completed">Completed</option>
                  </Input>
              </FormGroup>
          )}

          {/* <FormGroup>
            <Label for="taskAssignee">Assignee (User ID)</Label>
            <Input type="text" name="user_id" id="taskAssignee" value={taskForm.user_id} onChange={handleTaskFormChange} placeholder="Enter User ID"/>
          </FormGroup> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSaveTask} disabled={!taskForm.title}>Save Task</Button>
          <Button color="secondary" onClick={() => toggleTaskModal()}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isDeleteConfirmModalOpen} toggle={closeDeleteConfirmModal} centered size="sm">
        <ModalHeader toggle={closeDeleteConfirmModal}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this task? This action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDeleteTask}>Delete</Button>
          <Button color="secondary" onClick={closeDeleteConfirmModal}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {/* Order Details Modal for Dashboard */}
{selectedOrderDetails && (
<Modal
  isOpen={isDashboardOrderModalOpen}
  toggle={toggleDashboardOrderModal}
  size="lg"
  centered
>
  <ModalHeader toggle={toggleDashboardOrderModal}>
    {selectedOrderDetails.customerName}<br/>
    Order #: {selectedOrderDetails.orderId}
  </ModalHeader>
  <ModalBody>
    {loadingDashboardOrder ? (
      <div className="text-center my-5">
        <i className="fa fa-spinner fa-spin fa-2x" />
      </div>
    ) : dashboardOrderDetails ? (
      <>
        {/* ─── Order Meta ────────────────────────────────────────────── */}
        <Row className="mb-3">
          <Col md="3">
            <strong>Date:</strong><br/>
            {new Date(dashboardOrderDetails.date).toLocaleDateString()}
          </Col>
          <Col md="3">
            <strong>Store #:</strong><br/>
            {dashboardOrderDetails.storeNumber || "–"}
          </Col>
          <Col md="3">
            <strong>PO #:</strong><br/>
            {dashboardOrderDetails.purchaseOrder || dashboardOrderDetails.orderId || "–"}
          </Col>
          <Col md="3">
            <strong>Distribution:</strong><br/>
            {dashboardOrderDetails.distribution || "–"}
          </Col>
        </Row>

        {/* Optional Pengelly # */}
        {dashboardOrderDetails.pick && (
          <Row className="mb-3">
            <Col md="3">
              <strong>Pengelly #:</strong><br/>
              {dashboardOrderDetails.pick}
            </Col>
          </Row>
        )}

        {/* ─── Order-level Notes ───────────────────────────────────────── */}
        {dashboardOrderDetails.notes && (
          <Row className="mb-3">
            <Col>
              <strong>Notes:</strong>
              <div
                className="p-2 border rounded"
                style={{ whiteSpace: "pre-wrap", maxHeight: "100px", overflowY: "auto" }}
              >
                {dashboardOrderDetails.notes}
              </div>
            </Col>
          </Row>
        )}

        {/* ─── Line Items ─────────────────────────────────────────────── */}
        {(dashboardOrderDetails.updatedAt || dashboardOrderDetails.updatedByEmail) && (
          <div className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>
            Updated: {dashboardOrderDetails.updatedAt
              ? new Date(dashboardOrderDetails.updatedAt).toLocaleString("en-NZ")
              : "—"}
            {" "}by {dashboardOrderDetails.updatedByEmail || "—"}
          </div>
        )}
        <h5 className="mb-2">Products Ordered</h5>
        <div
          style={{
            maxHeight: "250px",
            overflowY: "auto",
            overflowX: "hidden",
            marginBottom: "1rem"
          }}
        >
          <Table hover size="sm">
            <thead className="thead-light">
              <tr>
                <th>Product</th>
                <th className="text-right">Qty</th>
                <th className="text-right">Bonus</th>
                <th className="text-right">Price</th>
                <th className="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {getNormalizedItems(dashboardOrderDetails).map((item, i) => (
                <tr key={i}>
                  <td>{item.name}</td>
                  <td className="text-right">{item.quantity}</td>
                  <td className="text-right">{item.bonusQuantity || 0}</td>
                  <td className="text-right">${item.price.toFixed(2)}</td>
                  <td className="text-right">${item.total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* ─── Order Total ───────────────────────────────────────────── */}
        <Row>
          <Col className="text-right">
            <h5>
              Grand Total: $
              {getNormalizedItems(dashboardOrderDetails)
                .reduce((sum, i) => sum + i.total, 0)
                .toFixed(2)}
            </h5>
          </Col>
        </Row>
      </>
    ) : (
      <p className="text-center text-danger">
        Unable to load order details.
      </p>
    )}
  </ModalBody>
  <ModalFooter className="d-flex justify-content-between px-4 py-2">
    <div className="d-flex">
      {canEditOrderEntries ? (
        <Button
          color="warning"
          onClick={handleOpenEditConfirm}
          disabled={loadingDashboardOrder || !dashboardOrderDetails}
          style={{ marginRight: "0.5rem" }}
        >
          Edit
        </Button>
      ) : null}
      <Button
        color="danger"
        onClick={handleOpenDeleteConfirm}
        disabled={loadingDashboardOrder || !dashboardOrderDetails}
      >
        Delete
      </Button>
    </div>
    <Button color="secondary" onClick={toggleDashboardOrderModal}>
      Close
    </Button>
  </ModalFooter>
</Modal>

)}
      <Modal
        isOpen={confirmEditOrderOpen}
        toggle={handleCancelEditOrder}
        centered
      >
        <ModalHeader toggle={handleCancelEditOrder}>
          Confirm Edit
        </ModalHeader>
        <ModalBody>
          This can not be undone. Are you sure you want to edit this order?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCancelEditOrder}>
            Cancel
          </Button>
          <Button color="warning" onClick={handleConfirmEditOrder}>
            Yes, Edit Order
          </Button>
        </ModalFooter>
      </Modal>
      <AddNewOrderModal
        isOpen={editOrderModalOpen}
        toggle={toggleEditOrderModal}
        onSave={handleDashboardOrderSave}
        existingOrder={orderBeingEdited}
      />
      <Modal
        isOpen={confirmDeleteOrderOpen}
        toggle={handleCancelDeleteOrder}
        centered
      >
        <ModalHeader toggle={handleCancelDeleteOrder}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this order? This can not be undone.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCancelDeleteOrder}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={handleConfirmDeleteOrder}
            disabled={deletingOrder}
          >
            {deletingOrder ? "Deleting..." : "Delete"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Dashboard;
